// productData.js
const productData = [
  // 📱 GADGETS & TECH
  {
    category: "📱 Gadgets & Tech",
    subcategory: "📲 Smartphones & Tablets",
    products: [
      {
        name: "iPhone",
       models: [
   "iPhone 6", "iPhone 6 Plus", "iPhone 6s",
  "iPhone 6s Plus", "iPhone 7",
  "iPhone 7 Plus", "iPhone 8", "iPhone 8 Plus", "iPhone X", "iPhone XR",
  "iPhone XS", "iPhone XS Max", "iPhone 11", "iPhone 11 Pro",
  "iPhone 11 Pro Max", "iPhone SE (2nd generation)", "iPhone 12",
  "iPhone 12 Mini", "iPhone 12 Pro", "iPhone 12 Pro Max", "iPhone 13",
  "iPhone 13 Mini", "iPhone 13 Pro", "iPhone 13 Pro Max", "iPhone SE (3rd generation)",
  "iPhone 14", "iPhone 14 Plus", "iPhone 14 Pro", "iPhone 14 Pro Max",
  "iPhone 15", "iPhone 15 Plus", "iPhone 15 Pro", "iPhone 15 Pro Max",
  "iPhone 16", "iPhone 16 Plus", "iPhone 16e", "iPhone 16 Pro",
  "iPhone 16 Pro Max", "iPhone 17", "iPhone 17 Air", "iPhone 17 Pro",
  "iPhone 17 Pro Max", "Others"
]
      },
      {
  "name": "Samsung",
  "models": [
   
    "Galaxy S",
    "Galaxy S II",
    "Galaxy S III",
    "Galaxy S4",
    "Galaxy S5",
    "Galaxy S6",
    "Galaxy S7",
    "Galaxy S8",
    "Galaxy S9",
    "Galaxy S10e",
    "Galaxy S10",
    "Galaxy S10+",
    "Galaxy S20",
    "Galaxy S20+",
    "Galaxy S20 Ultra",
    "Galaxy S20 FE",
    "Galaxy S21",
    "Galaxy S21+",
    "Galaxy S21 Ultra",
    "Galaxy S21 FE",
    "Galaxy S22",
    "Galaxy S22+",
    "Galaxy S22 Ultra",
    "Galaxy S23",
    "Galaxy S23+",
    "Galaxy S23 Ultra",
    "Galaxy S23 FE",
    "Galaxy S24",
    "Galaxy S24+",
    "Galaxy S24 Ultra",
    "Galaxy S24 FE",
    "Galaxy Note",
    "Galaxy Note II",
    "Galaxy Note 3",
    "Galaxy Note 4",
    "Galaxy Note 5",
    "Galaxy Note 7",
    "Galaxy Note 8",
    "Galaxy Note 9",
    "Galaxy Note 10",
    "Galaxy Note 10+",
    "Galaxy Note 20",
    "Galaxy Note 20 Ultra",
    "Galaxy Z Fold",
    "Galaxy Z Fold2",
    "Galaxy Z Fold3",
    "Galaxy Z Fold4",
    "Galaxy Z Fold5",
    "Galaxy Z Fold6",
    "Galaxy Z Flip",
    "Galaxy Z Flip3",
    "Galaxy Z Flip4",
    "Galaxy Z Flip5",
    "Galaxy Z Flip6",
    "Galaxy A01",
    "Galaxy A02",
    "Galaxy A03",
    "Galaxy A04",
    "Galaxy A05",
    "Galaxy A06",
    "Galaxy A10",
    "Galaxy A11",
    "Galaxy A12",
    "Galaxy A13",
    "Galaxy A14",
    "Galaxy A15",
    "Galaxy A16",
    "Galaxy A20",
    "Galaxy A21",
    "Galaxy A22",
    "Galaxy A23",
    "Galaxy A24",
    "Galaxy A25",
    "Galaxy A26",
    "Galaxy A30",
    "Galaxy A31",
    "Galaxy A32",
    "Galaxy A33",
    "Galaxy A34",
    "Galaxy A35",
    "Galaxy A36",
    "Galaxy A40",
    "Galaxy A41",
    "Galaxy A42",
    "Galaxy A50",
    "Galaxy A51",
    "Galaxy A52",
    "Galaxy A53",
    "Galaxy A54",
    "Galaxy A55",
    "Galaxy A56",
    "Galaxy A70",
    "Galaxy A71",
    "Galaxy A72",
    "Galaxy A73",
    "Galaxy A80",
    "Galaxy A90", "Others"
  ]
}
,
     {
  "name": "Infinix",
  "models": [
    
  
    "Hot Note",
    "Hot 2",
    "Hot 3",
    "Hot S",
    "Hot 4",
    "Hot 4 Pro",
    "Hot 5",
    "Hot 5 Lite",
    "Hot S3",
    "Hot 6",
    "Hot 6 Pro",
    "Hot 6X",
    "Hot 7",
    "Hot 7 Pro",
    "Hot 8",
    "Hot 9",
    "Hot 9 Play",
    "Hot 9 Pro",
    "Hot 10",
    "Hot 10i",
    "Hot 10T",
    "Hot 10s",
    "Hot 10s NFC",
    "Hot 10 Lite",
    "Hot 10 Play",
    "Hot 11",
    "Hot 11 Play",
    "Hot 11s",
    "Hot 11 2022",
    "Hot 12",
    "Hot 12 Play",
    "Hot 12 Pro",
    "Hot 12i",
    "Hot 20",
    "Hot 20 Play",
    "Hot 20s",
    "Hot 20 5G",
    "Hot 20i",
    "Hot 30",
    "Hot 30i",
    "Hot 30i NFC",
    "Hot 30 Play",
    "Hot 30 5G",
    "Hot 40",
    "Hot 40i",
    "Hot 40 Pro",
    "Hot 50",
    "Hot 50i",
    "Hot 50 5G",
    "Hot 50 Pro",
    "Hot 50 Pro+",
    "Hot 60",
    "Hot 60i",
    "Hot 60 5G+",
    "Hot 60 Pro",
    "Hot 60 Pro+",
    "Note 2",
    "Note 3",
    "Note 3 Pro",
    "Note 4",
    "Note 4 Pro",
    "Note 5",
    "Note 5 Stylus",
    "Note 6",
    "Note 7",
    "Note 7 Lite",
    "Note 8",
    "Note 8i",
    "Note 9",
    "Note 10",
    "Note 10 Pro",
    "Note 11",
    "Note 11 Pro",
    "Note 11 Pro NFC",
    "Note 11i",
    "Note 11s",
    "Note 12",
    "Note 12 5G",
    "Note 12 Pro",
    "Note 12 Pro 5G",
    "Note 12 G96",
    "Note 12i",
    "Note 12i 2022",
    "Note 12 2023",
    "Note 12 VIP",
    "Note 30",
    "Note 30 Pro",
    "Note 30 5G",
    "Note 30 VIP",
    "Note 30i",
    "Note 40",
    "Note 40 5G",
    "Note 40 Pro",
    "Note 40 Pro 5G",
    "Note 40 Pro+ 5G",
    "Note 40X 5G",
    "Note 40S",
    "Note 40 Racing Edition",
    "Note 50",
    "Note 50 Pro",
    "Note 50 Pro+ 5G",
    "Note 50x 5G",
    "Note 50s 5G",
    "Note 50s+ 5G",
    "Zero 2",
    "Zero 3",
    "Zero 4",
    "Zero 4 Plus",
    "Zero 5",
    "Zero 5 Pro",
    "Zero 6",
    "Zero 6 Pro",
    "Zero 8",
    "Zero 8i",
    "Zero 9",
    "Zero X",
    "Zero X Pro",
    "Zero X Neo",
    "Zero 5G",
    "Zero 20",
    "Zero 5G 2023",
    "Zero Ultra",
    "Zero 30",
    "Zero 30 5G",
    "Zero 40",
    "Zero 40 5G",
    "Zero Flip",
    "S2",
    "S4",
    "S5",
    "S5 Lite",
    "S5 Pro",
    "Smart",
    "Smart 2",
    "Smart 2 HD",
    "Smart 2 Pro",
    "Smart 3 Plus",
    "Smart 4c",
    "Smart 4",
    "Smart 5",
    "Smart 6",
    "Smart 6 HD",
    "Smart 6 Plus",
    "Smart 7",
    "Smart 7 HD",
    "Smart 8",
    "Smart 8 HD",
    "Smart 8 Pro",
    "Smart 8 Plus",
    "Smart 9",
    "Smart 9 HD",
    "Smart 10",
    "Smart 10 Plus",
    "Smart 10 Pro",
    "Smart 10 HD",
    "GT 10 Pro",
    "GT 20 Pro",
    "GT 30 Pro",
    "GT 30",
    "Hot 60i 5G",
    "GT 30 5G+",
    "Smart 10",
    "Hot 60 5G+",
    "GT 30 Pro 5G",
    "Note 50s 5G+",
    "Note 50X 5G",
    "Smart 9 HD",
    "Zero Flip 5G",
    "Hot 50 5G",
    "Zero 40 5G",
    "Note 40X 5G",
    "Note 40 5G",
    "Note 40 Pro 5G",
    "Note 40 Pro+ 5G",
    "Smart 8 Plus",
    "Smart 8 HD",
    "Hot 40i",
    "Smart 8",
    "Zero 30 5G",
    "GT 10 Pro",
    "Hot 30 5G",
    "Note 30 5G",
    "Smart 7 HD",
    "Hot 30i",
    "Smart 7",
    "Zero 5G 2023 Turbo",
    "Zero 5G 2023",
    "Note 12i",
    "Hot 20 Play",
    "Hot 20 5G",
    "Zero Ultra 5G",
    "Note 12i (2022)",
    "Zero 20",
    "Note 12 Pro 4G",
    "Hot 12 Pro",
    "Hot 12 Play",
    "Note 12 Pro 5G",
    "Note 12 5G",
    "Smart 6 Plus",
    "Hot 12 Play",
    "Note 12 Turbo",
    "Smart 6 HD",
    "Hot 11 2022",
    "Zero 5G",
    "Note 11S",
    "Xpad 20 Pro",
    "Xpad 20",
    "Xpad GT",
    "Note 50s",
    "Note 50x",
    "Note 50 Pro+",
    "Note 50 Pro 4G",
    "Note 50 4G",
    "Smart 9 HD",
    "Hot 50 Pro 4G",
    "Hot 50 Pro+ 4G",
    "Note 40S",
    "Hot 50i",
    "Smart 9",
    "Hot 50 4G",
    "Zero Flip",
    "Hot 50",
    "Zero 40",
    "Zero 40 4G",
    "Xpad",
    "Note 40X 5G",
    "Note 40 5G",
    "GT 20 Pro",
    "Note 40 Pro+",
    "Note 40 Pro",
    "Note 40 Pro 4G",
    "Note 40",
    "Smart 8 Plus",
    "Smart 8 Pro",
    "Smart 8 (India)",
    "Smart 8 HD",
    "Hot 40 Pro",
    "Hot 40",
    "Hot 40i",
    "Smart 8",
    "Zero 30 4G",
    "Zero 30",
    "GT 10 Pro",
    "Hot 30 5G",
    "Note 30 VIP"
    , "Others"
  ]
}
,
     {
  "name": "Tecno",
  "models": [
    "Camon 40 Premier 5G", "Camon 40 Pro 5G", "Camon 40 Pro", "Camon 40",
    "Camon 30S Pro", "Camon 30S", "Camon 30 Premier 5G", "Camon 30 Pro 5G",
    "Camon 30 5G", "Camon 30", "Camon 20 Premier 5G", "Camon 20 Pro 5G",
    "Camon 20 Pro", "Camon 20", "Camon 19 Pro 5G", "Camon 19 Pro",
    "Camon 19 Neo", "Camon 19", "Camon 18 Premier", "Camon 18P",
    "Camon 18T", "Camon 18i", "Camon 18", "Camon 17 Pro",
    "Camon 17P", "Camon 17", "Camon 16 Premier", "Camon 16 Pro",
    "Camon 16s", "Camon 16", "Camon 15 Premier", "Camon 15 Pro",
    "Camon 15 Air", "Camon 15", "Camon 12 Pro", "Camon 12 Air",
    "Camon 12", "Camon 11 Pro", "Camon 11",
    "Spark 40 Pro+", "Spark 40 Pro", "Spark 40",
    "Spark 30 Pro", "Spark 30 5G", "Spark 30", "Spark 30C 5G",
    "Spark 30C", "Spark 20 Pro+", "Spark 20 Pro 5G", "Spark 20 Pro",
    "Spark 20 5G", "Spark 20", "Spark 20C", "Spark 10 Pro",
    "Spark 10 5G", "Spark 10", "Spark 10C", "Spark 9 Pro",
    "Spark 9T", "Spark 9", "Spark 8 Pro", "Spark 8P",
    "Spark 8", "Spark 8C", "Spark Go 2024", "Spark Go 2023",
    "Spark Go 2022", "Spark Go 2020", "Spark Go",
    "Pova 7 Ultra 5G", "Pova 7 Pro 5G", "Pova 7 5G", "Pova 7",
    "Pova 6 Pro 5G", "Pova 6 Neo 5G", "Pova 6 Neo", "Pova 6",
    "Pova 5 Pro", "Pova 5", "Pova Neo 3", "Pova Neo 5G",
    "Pova Neo", "Pova 4 Pro", "Pova 4", "Pova 3",
    "Pova 2", "Pova",
    "Phantom V Fold 2 5G", "Phantom V Flip 2 5G", "Phantom V Fold",
    "Phantom V Flip", "Phantom X2 Pro", "Phantom X2", "Phantom X",
    "Phantom 9", "Phantom 8",
    "Pop 10 Pro", "Pop 10", "Pop 9 5G", "Pop 9 4G", "Pop 8",
    "Pop 7 Pro", "Pop 7", "Pop 6 Pro", "Pop 6 Go", "Pop 6",
    "Pop 5S", "Pop 5X", "Pop 5P", "Pop 5", "Pop 4 Pro",
    "Pop 4", "Pop 3 Plus", "Pop 3", "Pop 2F", "Pop 2",
    "Pop", "Others"
  ]
}
,

{
  "name": "Xiaomi",
  "models": [
    "Mi 1",
    "Mi 1S",
    "Mi 2",
    "Mi 2S",
    "Mi 2A",
    "Mi 3",
    "Mi 4",
    "Mi 4i",
    "Mi 4c",
    "Mi 4S",
    "Mi 5",
    "Mi 5 Pro/Prime",
    "Mi 5s",
    "Mi 5s Plus",
    "Mi 5c",
    "Mi 5X (Mi A1)",
    "Mi 6",
    "Mi 6X (Mi A2)",
    "Mi 8",
    "Mi 8 Lite",
    "Mi 8 SE",
    "Mi 8 Pro",
    "Mi 8 Explorer Edition",
    "Mi 9",
    "Mi 9 Lite",
    "Mi 9 SE",
    "Mi 9T (Redmi K20)",
    "Mi 9T Pro (Redmi K20 Pro)",
    "Mi 10",
    "Mi 10 Pro",
    "Mi 10 Ultra",
    "Mi 10 Lite",
    "Mi 10T",
    "Mi 10T Pro",
    "Mi 10T Lite",
    "Mi 11",
    "Mi 11 Pro",
    "Mi 11 Ultra",
    "Mi 11 Lite",
    "Mi 11 Lite 5G NE",
    "Mi 11i",
    "Mi MIX",
    "Mi MIX 2",
    "Mi MIX 2S",
    "Mi MIX 3",
    "Mi MIX 4",
    "Xiaomi MIX Fold",
    "Xiaomi MIX Fold 2",
    "Xiaomi MIX Fold 3",
    "Xiaomi MIX Flip",
    "Mi Note",
    "Mi Note Pro",
    "Mi Note 2",
    "Mi Note 3",
    "Mi Max",
    "Mi Max 2",
    "Mi Max 3",
    "Xiaomi 12",
    "Xiaomi 12 Pro",
    "Xiaomi 12X",
    "Xiaomi 12 Lite",
    "Xiaomi 12S Ultra",
    "Xiaomi 12T",
    "Xiaomi 12T Pro",
    "Xiaomi 13",
    "Xiaomi 13 Pro",
    "Xiaomi 13 Ultra",
    "Xiaomi 13 Lite",
    "Xiaomi 13T",
    "Xiaomi 13T Pro",
    "Xiaomi 14",
    "Xiaomi 14 Pro",
    "Xiaomi 14 Ultra",
    "Xiaomi 14 Civi",
    "Xiaomi 14T",
    "Xiaomi 14T Pro",
    "Xiaomi 15",
    "Xiaomi 15 Pro",
    "Xiaomi 15 Ultra",
    "Xiaomi 15T",
    "Xiaomi 15T Pro",
    "Others"
  ]
}


,

{
  "name": "Redmi",
  "models": [
    "Redmi (original)",
    "Redmi 1S",
    "Redmi 2",
    "Redmi 2 Prime",
    "Redmi 3",
    "Redmi 3S",
    "Redmi 3 Prime",
    "Redmi 3X",
    "Redmi 4A",
    "Redmi 4X",
    "Redmi 4 (India)",
    "Redmi 4 Prime",
    "Redmi 5A",
    "Redmi 5",
    "Redmi 5 Plus",
    "Redmi 6",
    "Redmi 6A",
    "Redmi 6 Pro",
    "Redmi 7",
    "Redmi 7A",
    "Redmi 8",
    "Redmi 8A",
    "Redmi 9",
    "Redmi 9A",
    "Redmi 9C",
    "Redmi 9T",
    "Redmi 10",
    "Redmi 10A",
    "Redmi 10C",
    "Redmi 10 (2022)",
    "Redmi 12",
    "Redmi 12C",
    "Redmi 13",
    "Redmi 13C",
    "Redmi 13x",
    "Redmi 14C",
    "Redmi 15",
    "Redmi 15C",
    "Redmi A Series (A1+, A3, A3x, A5, etc.)",
    "Redmi Pro",
    "Redmi S2/Y2",
    "Redmi Note (original)",
    "Redmi Note 2",
    "Redmi Note 3",
    "Redmi Note 4",
    "Redmi Note 4X",
    "Redmi Note 5",
    "Redmi Note 5 Pro",
    "Redmi Note 6 Pro",
    "Redmi Note 7",
    "Redmi Note 7 Pro",
    "Redmi Note 8",
    "Redmi Note 8 Pro",
    "Redmi Note 8T",
    "Redmi Note 9",
    "Redmi Note 9 Pro",
    "Redmi Note 9S",
    "Redmi Note 9 Pro Max",
    "Redmi Note 9 5G",
    "Redmi Note 10",
    "Redmi Note 10 Pro",
    "Redmi Note 10S",
    "Redmi Note 10 5G",
    "Redmi Note 11",
    "Redmi Note 11 Pro",
    "Redmi Note 11S",
    "Redmi Note 11 Pro+ 5G",
    "Redmi Note 12",
    "Redmi Note 12 Pro",
    "Redmi Note 12S",
    "Redmi Note 12 Pro+ 5G",
    "Redmi Note 13",
    "Redmi Note 13 Pro",
    "Redmi Note 13 Pro+",
    "Redmi Note 13 5G",
    "Redmi Note 14",
    "Redmi Note 14 Pro",
    "Redmi Note 14 Pro+",
    "Redmi Note 14 5G",
    "Redmi Note 14S",
    "Redmi Note 15 (China)",
    "Redmi Note 15 Pro",
    "Redmi Note 15 Pro+",
    "Redmi Note 14T",
    "Redmi Note 15T",
    "Redmi Note 15 Ultra",
    "Redmi K20",
    "Redmi K20 Pro",
    "Redmi K30",
    "Redmi K30 Pro",
    "Redmi K30 Ultra",
    "Redmi K30S",
    "Redmi K40",
    "Redmi K40 Pro",
    "Redmi K40 Gaming",
    "Redmi K50",
    "Redmi K50 Pro",
    "Redmi K50 Gaming",
    "Redmi K60",
    "Redmi K60 Pro",
    "Redmi K60 Ultra",
    "Redmi K70",
    "Redmi K70 Pro",
    "Redmi K70 Ultra",
    "Redmi K80 Ultra",
    "Redmi K90",
    "Redmi K90 Pro Max",
    "Redmi Turbo 4 Pro",
    "Others"
  ]
}
,



    {
  "name": "iPad",
  "models": [
    
    "iPad (1st-10th generation)",
    "iPad (11th generation)",
    "iPad Air (1st-5th generation)",
    "iPad Air 11-inch (M3)",
    "iPad Air 13-inch (M3)",
    "iPad mini (1st-5th generation)",
    "iPad mini (6th generation)",
    "iPad mini (A17 Pro)",
    "iPad Pro 9.7-inch",
    "iPad Pro 10.5-inch",
    "iPad Pro 11-inch (1st-4th generation)",
    "iPad Pro 11-inch (M4)",
    "iPad Pro 11-inch (M5)",
    "iPad Pro 12.9-inch (1st-6th generation)",
    "iPad Pro 13-inch (M4)",
    "iPad Pro 13-inch (M5)", "Others"
  ]
}
,

     {
  "name": "Phone Tablet Accessories",
  "models": [
    "Smart Cover", "Stylus Pen", "Keyboard Case", "Protective Case",
    "Rugged Case", "Folio Case", "Screen Protector (Tempered Glass)",
    "Screen Protector (Film)", "Folding Stand", "Rotating Stand",
    "Tablet Tripod Mount", "Tablet Car Mount", "Fast Charger",
    "Multi-port Charger", "Charging Cable", "Portable Power Bank",
    "Magnetic Charging Cable", "Bluetooth Headphones", "Wireless Earbuds",
    "Carrying Bag", "Sleeve", "Microfiber Cleaning Cloth", "Screen Cleaning Spray",
    "Keyboard Brush", "Others"
  ]
}
,

    ],
  },

 {
    category: "📱 Gadgets & Tech",
    subcategory: "🔌 Accessories for Phones & Tablets",
    products: [
     {
  "name": "Power Bank",
  "models": [
    
    "Oraimo",
    "Anker",
    "New Age",
    "Romoss",
    "Tecno",
    "itel",
    "Samsung",
    "Baseus",
    "Digifon",
    "Ace Elec",
    "EASYPIE",
    "Philly",
    "VIC",
    "GDTINA",
    "KingElec",
    "Xiaomi",
    "Ugreen",
    "Bluedi",
    "Yoobao",
    "Joyroom",
    "Powerology",
    "Green Lion",
    "Move Speed",
    "Apple MagSafe",
    "Mophie",
    "Aukey",
    "Belkin",
    "Porodo", "Others"
  ]
}
,
      {
  "name": "Charger & Power Adapters",
  "models": [
    
    "Oraimo",
    "Samsung",
    "Ldnio",
    "Baseus",
    "Apple",
    "Anker",
    "Poga",
    "Shplus",
    "Tecno",
    "New Age",
    "Powerology",
    "Xiaomi",
    "Google",
    "Porodo",
    "Green Lion",
    "Promate",
    "Digifon",
    "Poolee",
    "itel",
    "Havit",
    "Remax",
    "Romoss",
    "Belkin",
    "Ugreen",
    "Wiwu",
    "Budi",
    "Chupez",
    "Infinix",
    "Oale",
    "AGM",
    "Universal",
    "OEM", "Others"
  ]
}
,
     {
  "name": "Cases",
  "models": [
    
    "Apple",
    "Samsung",
    "Oraimo",
    "Tecno",
    "Infinix",
    "Spigen",
    "Nillkin",
    "Otterbox",
    "UAG (Urban Armor Gear)",
    "Xundd",
    "Cooyee",
    "Baseus",
    "Guess",
    "JBL",
    "Casebus",
    "Santa Barbara Polo & Racquet Club",
    "Urban Armor Gear (UAG)",
    "Nomad",
    "Case-mate",
    "SUPCASE",
    "Pelican",
    "Ringke",
    "Tech21", "Others"
  ]
}
,
     {
  "name": "Phone Screens",
  "models": [
    
    "Samsung Galaxy Screen",
    "iPhone Screen",
    "Infinix Screen",
    "Tecno Screen",
    "Xiaomi Screen",
    "Huawei Screen",
    "Google Pixel Screen",
    "Oukitel Screen",
    "Blackview Screen",
    "LG Screen",
    "Umidigi Screen",
    "Incell Screen",
    "OLED Screen",
    "LCD Screen", "Others"
  ]
},

      {
  "name": "Stands & Holder",
  "models": [
    
    "Oraimo",
    "Baseus",
    "Anker",
    "New Age",
    "JBL",
    "Havit",
    "Devia",
    "Promate",
    "Joyroom",
    "Digifon",
    "Infinix",
    "Tecno",
    "Samsung",
    "Apple",
    "Ugreen",
    "Lamicall",
    "Popsocket",
    "Xiaomi",
    "Porodo",
    "Fimi",
    "Dji",
    "Universal", "Others"
  ]
}
,
      {
  "name": "Cables",
  "models": [
    
    "Oraimo",
    "Baseus",
    "Anker",
    "Joyroom",
    "Samsung",
    "Apple",
    "Ugreen",
    "Tecno",
    "Infinix",
    "Ldnio",
    "New Age",
    "Xiaomi",
    "Promate",
    "Remax",
    "Romoss",
    "Digifon",
    "Belkin",
    "Nillkin",
    "Havit",
    "Universal",
    "OEM", "Others"
  ]
}
,
     {
  "name": "Bluetooth Headsets",
  "models": [
     
    "Oraimo",
    "Anker",
    "itel",
    "Tecno",
    "Infinix",
    "Samsung",
    "JBL",
    "Sony",
    "Apple",
    "Beats",
    "Baseus",
    "Green Lion",
    "Promate",
    "Xiaomi",
    "Joyroom",
    "Remax",
    "Digifon",
    "Zealot",
    "Usams",
    "Havit",
    "Skullcandy",
    "P47",
    "Porodo",
    "Bose",
    "Logitech",
    "M10",
    "Aspor", "Others"
  ]
} , 
{
  "name": "Selfie Sticks",
  "models": [
    "L16",
    "P01",
    "P02",
    "P180",
    "Q07",
    "Q18",
    "Q515tk",
    "R1s",
    "JC-18h",
    "Insta360",
    "DJI",
    "Porodo",
    "Green Lion",
    "Earldom",
    "Hohem",
    "Yunteng",
    "Anker",
    "Neepho",
    "Havit",
    "Baseus",
    "Others"
  ]
}


    ],
  },





 {
  category: "📱 Gadgets & Tech",
  subcategory: "🎧 Headphones",
  products: [
    {
      name: "Apple Headphones",
      models: [
        
        "AirPods 2",
        "AirPods 3",
        "AirPods Pro",
        "AirPods Pro (2nd Gen)",
        "AirPods Max",
        "Beats Studio Pro",
        "Beats Fit Pro",
        "Beats Solo 4", "Others"
      ]
    },
    {
      name: "Sony Headphones",
      models: [
        
        "WH-1000XM4",
        "WH-1000XM5",
        "WF-1000XM5",
        "WH-CH720N",
        "WH-XB910N",
        "WF-C700N",
        "WF-1000XM4",
        "LinkBuds S", "Others"
      ]
    },
    {
      name: "JBL Headphones",
      models: [
        
        "Tune 510BT",
        "Tune 710BT",
        "Live 660NC",
        "Tour One M2",
        "Boombox 3",
        "Live Pro 2",
        "Reflect Flow Pro",
        "Tune 760NC", "Others"
      ]
    },
    {
      name: "Anker Headphones",
      models: [
        
        "Soundcore Q30",
        "Soundcore Q35",
        "Soundcore Q45",
        "Liberty 4",
        "Liberty 4 NC",
        "Liberty 3 Pro",
        "Life P3",
        "Life Dot 2", "Others"
      ]
    },
    {
      name: "Oraimo Headphones",
      models: [
        
        "FreePods 4",
        "FreePods 5",
        "BoomPop 2",
        "Riff 2",
        "FreePods Pro",
        "SoundGo 5",
        "FreePods Lite", "Others"
      ]
    },
    {
      name: "Samsung Headphones",
      models: [
        
        "Galaxy Buds 3 Pro",
        "Galaxy Buds 3",
        "Galaxy Buds 2 Pro",
        "Galaxy Buds 2",
        "Galaxy Buds FE",
        "Level U2",
        "AKG N700NCM2", "Others"
      ]
    },
    {
      name: "Logitech Headphones",
      models: [
        
        "Zone Vibe 100",
        "Zone Vibe 130",
        "Zone Vibe Wireless",
        "Zone Wireless 2",
        "G733 LIGHTSPEED",
        "G Pro X 2 LIGHTSPEED",
        "ASTRO A50 (Gen 5)",
        "H390 USB Headset", "Others"
      ]
    },
    {
      name: "Jabra Headphones",
      models: [
        
        "Elite 8 Active (Gen 2)",
        "Elite 10 (Gen 2)",
        "Elite 7 Pro",
        "Elite 5",
        "Elite 3",
        "Evolve2 65",
        "Evolve2 75",
        "Evolve2 40 SE", "Others"
      ]
    },
    {
      name: "Plantronics Headphones",
      models: [
        
        "Voyager Focus UC",
        "Voyager 6200 UC",
        "Voyager 5200 UC",
        "Savi 8245 UC",
        "Savi 8220",
        "Blackwire 5220",
        "Blackwire 3325",
        "BackBeat Pro 2", "Others"
      ]
    }
  ]
}

 , {
    category: "📱 Gadgets & Tech",
    subcategory: "⌚ Smart Watches",
   products: [
  {
    name: "Apple Watches",
    models: [
      
      "Ultra 3",
      "Series 11",
      "SE (3rd Gen)",
      "Series 10",
      "Ultra 2",
      "Series 9",
      "Series 8",
      "Ultra",
      "SE (2nd Gen)", "Others"
    ]
  },
  {
    name: "Samsung Watches",
    models: [
      
      "Watch 7",
      "Watch 6",
      "Watch 5",
      "Galaxy Fit 3", "Others"
    ]
  },
  {
    name: "Oraimo Watches",
    models: [
      
      "Watch 2R (OSW-30)",
      "Watch Nova V 2.01",
      "Watch 3 Pro",
      "Watch ER (OSW-42)",
      "OSW-20",
      "OSW-16",
      "OSW-11",
      "Tempo W2 (OSW-20)",
      "OSW-11 Tempo", "Others"
    ]
  },
  {
    name: "Huawei Watches",
    models: [
      
      "Watch GT 5 Pro",
      "Watch GT 5",
      "Watch FIT 4 Pro",
      "Watch Fit 3",
      "Watch GT 4",
      "Watch Ultimate",
      "Watch GT 3 Pro",
      "Watch GT2",
      "Watch Fit 2",
      "Watch GT 2e", "Others"
    ]
  },
  {
    name: "Itel Watches",
    models: [
      
      "Apex N10",
      "Edge R1 Pro ISW-043",
      "Storm Ultra",
      "Storm Plus",
      "Fit O20",
      "ISW 041",
      "Smart Watch 1",
      "Lux L1",
      "Horizon",
      "Storm Ultra (ISW-023)",
      "Native Storm", "Others"
    ]
  },
  {
    name: "Fitbit Watches",
    models: [
      
      "Versa 4",
      "Sense 2",
      "Charge 6",
      "Versa 3",
      "Sense",
      "Inspire 3",
      "Charge 4",
      "Ace 2", "Others"
    ]
  },
  {
    name: "Amazfit Watches",
    models: [
      
      "Cheetah",
      "Balance",
      "Balance 2",
      "GTR 4",
      "GTS 4 mini",
      "Cheetah Pro",
      "T-rex 3 Outdoor",
      "T-rex Ultra",
      "GTR 3 Pro",
      "Active 2",
      "Active Edge", "Others"
    ]
  }
]

,
  },

  {
  category: "📱 Gadgets & Tech",
  subcategory: "💻 Tablets",
  products: [
    {
      name: "Apple Tablets",
      models: [
        
        "iPad Pro 13 (M4)",
        "iPad Pro 12.9 (M4)",
        "iPad Pro 11 (M4)",
        "iPad Pro 11 (M3)",
        "iPad Pro 12.9 (M3)",
        "iPad Pro 11 (M2)",
        "iPad Pro 12.9 (M2)",
        "iPad Air 13 (M2)",
        "iPad Air 11 (M2)",
        "iPad Air (M1)",
        "iPad Air (4th Gen)",
        "iPad (11th Gen, A16)",
        "iPad (10th Gen)",
        "iPad (9th Gen)",
        "iPad Mini (6th Gen, A15/A17 Pro)",
        "iPad Mini (5th Gen)",
        "iPad Pro 3rd Gen",
        "iPad Pro 2nd Gen",
        "iPad Pro 1st Gen",
        "iPad (8th Gen)",
        "iPad (7th Gen)",
        "iPad (6th Gen)", "Others"
      ]
    },
    {
      name: "Samsung Tablets",
      models: [
        
        "Galaxy Tab S10 Ultra",
        "Galaxy Tab S10+",
        "Galaxy Tab S10",
        "Galaxy Tab S9 Ultra",
        "Galaxy Tab S9+",
        "Galaxy Tab S9",
        "Galaxy Tab S9 FE",
        "Galaxy Tab S9 FE+",
        "Galaxy Tab S8 Ultra",
        "Galaxy Tab S8+",
        "Galaxy Tab S8",
        "Galaxy Tab S7 FE",
        "Galaxy Tab S7+",
        "Galaxy Tab S7",
        "Galaxy Tab S6 Lite",
        "Galaxy Tab A9+",
        "Galaxy Tab A9",
        "Galaxy Tab A8 (2023)",
        "Galaxy Tab A7 Lite",
        "Galaxy Tab Active",
        "Galaxy Tab S6",
        "Galaxy Tab S5e", "Others"
      ]
    },
    {
      name: "Atouch Tablets",
      models: [
        
        "Atouch X19",
        "Atouch X19 Pro",
        "Atouch A7+",
        "Atouch A36",
        "Atouch KT7",
        "Atouch A15",
        "Atouch X11",
        "Atouch X12",
        "Atouch X10",
        "Atouch Tab 8",
        "Atouch Tab 10", "Others"
      ]
    },
    {
      name: "Amazon Tablets",
      models: [
        
        "Fire Max 11",
        "Fire HD 10 (13th Gen / 2023)",
        "Fire HD 10 (11th Gen / 2021)",
        "Fire HD 8 (12th Gen / 2024)",
        "Fire HD 8 (2022)",
        "Fire 7 (10th Gen)",
        "Fire HD 10 Kids Pro",
        "Fire HD 8 Kids",
        "Fire HD 8 Kids Edition",
        "Fire HD 10 (2019)", "Others"
      ]
    },
    {
      name: "Xiaomi Tablets",
      models: [
        
        "Xiaomi Pad 7 Pro",
        "Xiaomi Pad 7",
        "Redmi Pad 2 Pro",
        "Redmi Pad 2",
        "Redmi Pad 2 4G",
        "Redmi Pad SE (8.7)",
        "Xiaomi Pad 6 Pro",
        "Xiaomi Pad 6",
        "Xiaomi Pad 5",
        "Xiaomi Pad 5 Pro",
        "Xiaomi Pad Mini",
        "Redmi Pad", "Others"
      ]
    },
    {
      name: "Lenovo Tablets",
      models: [
        
        "Lenovo Tab P12 Pro",
        "Lenovo Tab P12",
        "Lenovo Tab P11 Pro (Gen 2)",
        "Lenovo Tab P11",
        "Lenovo Tab M11",
        "Lenovo Tab M10 Plus (Gen 3)",
        "Lenovo Yoga Tab 13",
        "Lenovo Yoga Tab 11",
        "Lenovo Tab M9",
        "Lenovo Tab K10",
        "Lenovo Tab M8",
        "Lenovo IdeaPad Duet", "Others"
      ]
    },
    {
      name: "Modlo Tablets",
      models: [
        
        "Modlo M10",
        "Modlo M8",
        "Modlo XPad 10",
        "Modlo Tab Pro",
        "Modlo Tab Air",
        "Modlo T7",
        "Modlo Kids Tab", "Others"
      ]
    },
    {
      name: "Oraimo Tablets",
      models: [
        
        "Oraimo Watch 3 Pro",
        "Oraimo Watch Nova V",
        "Oraimo Watch 2R (OSW-30)",
        "Oraimo Watch ER (OSW-42)",
        "OSW-20",
        "OSW-16",
        "OSW-11",
        "Tempo W2 (OSW-20)",
        "Oraimo Band",
        "Oraimo Watch Lite", "Others"
      ]
    },
    {
      name: "Huawei Tablets",
      models: [
        
        "MatePad Pro 13.2",
        "MatePad 11.5",
        "MatePad 11.5 S",
        "MatePad SE",
        "MatePad Air",
        "MatePad 11",
        "MatePad T10",
        "MatePad T10s",
        "MediaPad M6",
        "Watch GT 5 Pro",
        "Watch GT 5",
        "Watch GT 3 Pro",
        "Watch GT 2",
        "Watch Fit 3",
        "Watch Fit 2", "Others"
      ]
    },
    {
      name: "Itel Tablets",
      models: [
        
        "Itel PrimeTab 10",
        "Itel Pad One",
        "Itel Pad 1",
        "Itel PrimeTab 7",
        "Itel Pad Pro",
        "Apex N10",
        "Edge R1 Pro ISW-043",
        "Storm Ultra",
        "Storm Plus",
        "Fit O20",
        "ISW 041",
        "Smart Watch 1",
        "Lux L1",
        "Horizon", "Others"
      ]
    },
    {
      name: "Fitbit Tablets",
      models: [
        
        "Versa 4",
        "Versa 3",
        "Sense 2",
        "Sense",
        "Charge 6",
        "Charge 5",
        "Charge 4",
        "Inspire 3",
        "Inspire 2",
        "Ace 3",
        "Ace 2", "Others"
      ]
    },
    {
      name: "Amazfit Tablets",
      models: [
        
        "T-Rex 3 Pro",
        "T-Rex 3",
        "T-Rex Ultra",
        "Balance 2",
        "Balance",
        "GTR 4",
        "GTR 3 Pro",
        "GTR 3",
        "GTS 4 mini",
        "GTS 4",
        "Active 2",
        "Active Edge",
        "Cheetah",
        "Cheetah Pro",
        "Bip 6",
        "Falcon",
        "Helio Strap", "Others"
      ]
    }
  ]
},




  // 💻 ELECTRONICS
  {
  category: "💻 Electronics",
  subcategory: "🖥️ Laptop & Computers",
  products: [
    {
      name: "Apple (MacBook)",
      models: [
        
        "MacBook Air M4 (2025)",
        "MacBook Air M3 (2024)",
        "MacBook Air M2 (2022)",
        "MacBook Air M1 (2020)",
        "MacBook Pro 14 (M4)",
        "MacBook Pro 16 (M4)",
        "MacBook Pro 14 (M3)",
        "MacBook Pro 16 (M3)",
        "MacBook Pro 13 (M2)",
        "MacBook Pro 13 (M1)",
        "MacBook Pro 16 (Intel)",
        "MacBook Pro 15 (Intel)",
        "MacBook 12 (Retina)", "Others"
      ]
    },
  {
  name: "HP",
  models: [
    
    "HP Pavilion 15",
    "HP Pavilion x360",
    "HP Pavilion Aero (Lightweight)",
    "HP Pavilion Gaming",
    "HP Spectre x360 14",
    "HP Spectre x360 16",
    "HP Spectre Folio",
    "HP Envy x360",
    "HP Envy (13-inch)",
    "HP Envy (17-inch)",
    "HP Victus 16",
    "HP Victus 15",
    "HP Omen 16",
    "HP Omen 17",
    "HP Omen Transcend (Gaming)",
    "HP EliteBook 840 G10",
    "HP EliteBook 830 G9",
    "HP EliteBook x360",
    "HP EliteBook 1000 series (Premium)",
    "HP ProBook 450 G10",
    "HP ProBook 400 series",
    "HP ProBook 600 series",
    "HP Notebook 14",
    "HP Notebook 15",
    "HP Stream 11",
    "HP Stream 14",
    "HP ZBook Firefly 14",
    "HP ZBook Power (Workstation)",
    "HP ZBook Fury (Workstation)",
    "HP Dragonfly G4",
    "HP Dragonfly Pro",
    "HP Chromebook 14",
    "HP Chromebook x360",
    "HP OmniBook X (New in 2024)",
    "HP OmniBook Ultra Flip (New in 2024)", "Others"
  ]
}

,
   




{
  name: "Dell",
  models: [
    
    "Dell Inspiron 14",
    "Dell Inspiron 15",
    "Dell Inspiron 16 Plus",
    "Dell Inspiron 16 2-in-1",
    "Dell XPS 13 Plus",
    "Dell XPS 15 OLED",
    "Dell XPS 16",
    "Dell XPS 17",
    "Dell Latitude 7420",
    "Dell Latitude 9440",
    "Dell Latitude 3000 series",
    "Dell Latitude 5000 series",
    "Dell Latitude 7000 series",
    "Dell Precision 3581",
    "Dell Precision 7680",
    "Dell Vostro 3500",
    "Dell Vostro 3520",
    "Dell G15 Gaming",
    "Dell G16 Gaming",
    "Dell Alienware x14",
    "Dell Alienware M15 R7",
    "Dell Alienware M16",
    "Dell Alienware M18",
    "Dell Alienware x16",
    "Dell Alienware x16 R2",
    "Dell Chromebook 11",
    "Dell Chromebook 3100", "Others"
  ]
}










  , {
  name: "Lenovo",
  models: [
    
    "Lenovo ThinkPad X1 Carbon Gen 12",
    "Lenovo ThinkPad X1 Nano Gen 3",
    "Lenovo ThinkPad X1 2-in-1 Gen 10",
    "Lenovo ThinkPad X13 Gen 5",
    "Lenovo ThinkPad P1 Gen 7",
    "Lenovo ThinkPad P16v",
    "Lenovo ThinkPad T14 Gen 5",
    "Lenovo ThinkPad T14s Gen 6",
    "Lenovo ThinkPad T16 Gen 3",
    "Lenovo ThinkPad L14 Gen 5",
    "Lenovo ThinkPad E14 Gen 6",
    "Lenovo ThinkPad Z13",
    "Lenovo IdeaPad 1",
    "Lenovo IdeaPad 3i",
    "Lenovo IdeaPad 5",
    "Lenovo IdeaPad Slim 3i Gen 9",
    "Lenovo IdeaPad Slim 5",
    "Lenovo IdeaPad Flex 5",
    "Lenovo IdeaPad Gaming 3",
    "Lenovo Legion 5",
    "Lenovo Legion 7i",
    "Lenovo Legion Pro 5",
    "Lenovo Legion Pro 7",
    "Lenovo Legion Slim 5",
    "Lenovo Legion 9i",
    "Lenovo Legion Go (Handheld)",
    "Lenovo Yoga 7i",
    "Lenovo Yoga 9i",
    "Lenovo Yoga Pro 7",
    "Lenovo Yoga Slim 7i",
    "Lenovo Yoga Book 9i",
    "Lenovo ThinkBook 13x",
    "Lenovo ThinkBook 14 G5",
    "Lenovo ThinkBook 14s Yoga",
    "Lenovo V14 Gen 5",
    "Lenovo V15",
    "Lenovo LOQ 15",
    "Lenovo Chromebook Duet",
    "Lenovo Chromebook 500e",
    "Lenovo IdeaPad Z710 (Older model)",
    "Lenovo ThinkPad Yoga 460 (Older model)", "Others"
  ]
}
,
    {
  name: "ASUS",
  models: [
    
    "ASUS VivoBook Go 14",
    "ASUS VivoBook 15",
    "ASUS VivoBook 16X",
    "ASUS VivoBook Flip 14",
    "ASUS VivoBook S15",
    "ASUS ZenBook 13",
    "ASUS ZenBook 14 OLED",
    "ASUS ZenBook Flip",
    "ASUS ZenBook Duo",
    "ASUS ROG Zephyrus G14",
    "ASUS ROG Zephyrus G15",
    "ASUS ROG Zephyrus G16",
    "ASUS ROG Zephyrus M15",
    "ASUS ROG Strix G15",
    "ASUS ROG Strix G18",
    "ASUS ROG Strix Scar 15",
    "ASUS TUF A15",
    "ASUS TUF A16",
    "ASUS TUF F15",
    "ASUS TUF Dash F15",
    "ASUS ExpertBook B5",
    "ASUS ExpertBook B9",
    "ASUS Chromebook C223",
    "ASUS Chromebook C434",
    "ASUS Chromebook Flip C302CA",
    "ASUS ProArt StudioBook",
    "ASUS ROG Ally (Handheld Console)", "Others"
  ]
}
,
   {
  name: "Acer",
  models: [
    
    "Acer Aspire Go 15",
    "Acer Aspire Lite",
    "Acer Aspire 3",
    "Acer Aspire 5",
    "Acer Aspire 7",
    "Acer Aspire Vero",
    "Acer Aspire Gaming (7 Series)",
    "Acer Swift 3",
    "Acer Swift 14",
    "Acer Swift Go 14",
    "Acer Swift Go 16",
    "Acer Swift X",
    "Acer Swift Edge",
    "Acer Swift Spin",
    "Acer Spin 3",
    "Acer Spin 5",
    "Acer Nitro 5",
    "Acer Nitro 16",
    "Acer Nitro 17",
    "Acer Nitro V 15",
    "Acer Predator Helios 16",
    "Acer Predator Helios 300",
    "Acer Predator Helios Neo 16",
    "Acer Predator Helios Neo",
    "Acer Predator Triton",
    "Acer Chromebook 311",
    "Acer Chromebook Spin 713",
    "Acer TravelMate B3",
    "Acer TravelMate P2",
    "Acer TravelMate P4",
    "Acer TravelMate P6",
    "Acer Extensa", "Others"
  ]
}
,
   {
  name: "MSI",
  models: [
    
    "MSI Katana 15",
    "MSI Katana 17",
    "MSI Katana GF66",
    "MSI Katana GF76",
    "MSI Cyborg 14",
    "MSI Cyborg 15",
    "MSI Crosshair 16",
    "MSI Crosshair 17",
    "MSI Pulse GL66",
    "MSI Pulse 16 AI",
    "MSI Pulse 17 AI",
    "MSI Vector GP68 HX",
    "MSI Vector 16 HX AI",
    "MSI Raider GE68 HX",
    "MSI Raider A18 HX AI",
    "MSI Stealth 14 Studio",
    "MSI Stealth 16 Studio",
    "MSI Stealth 17 Studio",
    "MSI Stealth A18 AI+",
    "MSI Titan GT77 HX",
    "MSI Titan 18 HX AI",
    "MSI Prestige 13 AI Evo",
    "MSI Prestige 14",
    "MSI Prestige 16 AI Studio",
    "MSI Creator Z17 HX",
    "MSI CreatorPro Z16P",
    "MSI Modern 14",
    "MSI Modern 15",
    "MSI Summit E13 Flip Evo", "Others"
  ]
}
,
   {
  name: "Razer",
  models: [
    
    "Razer Blade 14",
    "Razer Blade 15",
    "Razer Blade 16",
    "Razer Blade 18",
    "Razer Blade Stealth",
    "Razer Blade Advanced",
    "Razer Blade Pro",
    "Razer Blade Studio Edition",
    "Razer Book 13",
    "Razer Book 14",
    "Razer Edge (Gaming Tablet)",
    "Razer Edge 5G (Handheld)",
    "Razer Chromebook 13", "Others"
  ]
}
,
    {
  name: "Samsung (Laptop & Computers)",
  models: [
    
    "Samsung Galaxy Book",
    "Samsung Galaxy Book Go",
    "Samsung Galaxy Book2",
    "Samsung Galaxy Book2 Pro",
    "Samsung Galaxy Book2 Pro 360",
    "Samsung Galaxy Book3",
    "Samsung Galaxy Book3 Pro",
    "Samsung Galaxy Book3 Pro 360",
    "Samsung Galaxy Book3 Ultra",
    "Samsung Galaxy Book4",
    "Samsung Galaxy Book4 360",
    "Samsung Galaxy Book4 Edge",
    "Samsung Galaxy Book4 Pro",
    "Samsung Galaxy Book4 Pro 360",
    "Samsung Galaxy Book4 Ultra",
    "Samsung Galaxy Book Flex",
    "Samsung Galaxy Chromebook",
    "Samsung Galaxy Chromebook Plus",
    "Samsung Galaxy Chromebook 2",
    "Samsung Galaxy Chromebook 2 360",
    "Samsung Galaxy Chromebook Go",
    "Samsung Galaxy Chromebook 4",
    "Samsung Galaxy Chromebook 4+",
    "Samsung Chromebook Go 11",
    "Samsung Chromebook 2 XE500C12",
    "Samsung Chromebook Plus V2",
    "Samsung N110",
    "Samsung N145",
    "Samsung NC10",
    "Samsung R530",
    "Samsung Series 3 305C",
    "Samsung Series 5 550P",
    "Samsung Series 9 900X", "Others"
  ]
}
,
   {
  name: "Microsoft (Laptop & Computers)",
  models: [
    
    "Surface Laptop 7 (Copilot+)",
    "Surface Laptop 6",
    "Surface Laptop 5",
    "Surface Laptop 4",
    "Surface Laptop 3",
    "Surface Laptop 2",
    "Surface Laptop (1st Gen)",
    "Surface Laptop Go 3",
    "Surface Laptop Go 2",
    "Surface Laptop Studio 2",
    "Surface Laptop Studio",
    "Surface Pro 11 (Copilot+)",
    "Surface Pro 10 for Business",
    "Surface Pro 9",
    "Surface Pro 8",
    "Surface Pro 7+",
    "Surface Pro 7",
    "Surface Pro 6",
    "Surface Pro (5th Gen)",
    "Surface Pro 4",
    "Surface Pro 3",
    "Surface Pro 2",
    "Surface Pro X",
    "Surface Go 4 for Business",
    "Surface Go 3",
    "Surface Go 2",
    "Surface Go (1st Gen)",
    "Surface Book 3",
    "Surface Book 2",
    "Surface Book (1st Gen)",
    "Surface Studio 2+",
    "Surface Studio 2", "Others"
  ]
}
,
    {
      name: "Others (Laptop & Computers)",
      models: [
        
        "Chromebooks",
        "Mini PCs",
        "Refurbished PCs",
        "All-in-One Desktops",
        "Custom Gaming PCs",
        "iMac",
        "Hackintosh PCs", "Others"
      ]
    }
  ]
}  , 
{
    category: "💻 Electronics",
    subcategory: "📺 TV & DVD Equipment",
    products: [ 
        {
    "name": "Television",
    "models": [
      "LG",
      "Samsung",
      "Hisense",
      "TCL",
      "Sony",
      "Polystar",
      "Skyrun",
      "Bruhm",
      "iTEC",
      "Kenstar",
      "Maxi",
      "JVC",
      "Others"
    ]
  },
  {
    "name": "TVs",
    "models": [
      "LG",
      "Samsung",
      "Hisense",
      "TCL",
      "Sony",
      "Polystar",
      "Skyrun",
      "Bruhm",
      "iTEC",
      "Kenstar",
      "Maxi",
      "JVC",
      "Others"
    ]
  },
  {
    "name": "TV Boxes",
    "models": [
      "Xiaomi",
      "MXQ Pro",
      "H96",
      "T95",
      "Mecool",
      "Airtel",
      "Tanix",
      "Roku",
      "Apple",
      "Cyberstick",
      "Google Chromecast",
      "Amazon Fire TV",
      "Mortal",
      "KICKPI",
      "Dcolor",
      "Others"
    ]
  },
  {
    "name": "Projectors",
    "models": [
      "Optoma",
      "Hisense",
      "Havit",
      "Transpeed",
      "Magcubic",
      "Acer",
      "Epson",
      "Philips",
      "ViewSonic",
      "Sony",
      "Green Lion",
      "Samsung",
      "Owlenz",
      "Others"
    ]
  },
  {
    "name": "TV Receivers",
    "models": [
      "Strong",
      "Viewsat",
      "GTMEDIA",
      "SLTV",
      "Moreplex",
      "Free to Air receivers (Various)"
    ]
  },
  {
    "name": "Media Players",
    "models": [
      "Roku",
      "Apple TV",
      "Google Chromecast",
      "Amazon Fire TV Stick",
      "Xiaomi Mi Box",
      "Mortal",
      "X96",
      "H96",
      "Others"
    ]
  },
  {
    "name": "Decoders",
    "models": [
      "GOtv",
      "DStv",
      "StarTimes",
      "Strong",
      "Moreplex",
      "SLTV",
      "Viewsat",
      "Others"
    ]
  },
  {
    "name": "Blu-Ray Players",
    "models": [
      "Sony",
      "Samsung",
      "LG",
      "Others"
    ]
  }
]
,
  }, 
  {
    category: "💻 Electronics",
    subcategory: "📸 Photo & Video Cameras",
    products: [
    {
  name: "Digital Cameras",
  models: [
    
    "Canon",
    "Nikon",
    "Sony",
    "Fujifilm",
    "Panasonic",
    "Blackmagic",
    "GoPro",
    "DJI",
    "Insta360",
    "Kodak",
    "Samsung",
    "OM System (formerly Olympus)", "Others"
  ]
}

,
   {
  name: "Video Cameras",
  models: [
    
    "Sony",
    "Canon",
    "Blackmagic",
    "Panasonic",
    "GoPro",
    "DJI",
    "Insta360",
    "Nikon",
    "JVC",  "Others"
  ]
}


,
      {
  name: "Drones",
  models: [
    
    "DJI",
    "Fimi",
    "Holy Stone",
    "Autel",
    "Potensic",
    "Others"
  ]
}
,
   {
  name: "DSLR Cameras",
  models: [
    
    "Canon",
    "Nikon",
    "Pentax",
    "Sony", "Others"
  ]
}
,

{
  name: "Action Cameras",
  models: [
    
    "GoPro",
    "DJI",
    "Insta360",
    "Sony",
    "Others"
  ]
},
{
  name: "Film Cameras",
  models: [
    
    "Canon",
    "Nikon",
    "Leica",
    "Hasselblad",
    "Mamiya",
    "Pentax",
    "Olympus",
    "Minolta",
    "Yashica",
    "Contax",
    "Fujifilm",
    "Kodak",
    "Others Cameras"
  ]
}


     
    ],
  },  



 {
    category: "💻 Electronics",
    subcategory: "🎮 Video Game Consoles",
    products: [
  {
  name: "Playstation , Ps , Xbox",
  models: [
    
    "Sony (Video Game Consoles)",
    "Microsoft (Video Game Consoles)",
    "Nintendo (Video Game Consoles)",
    "Meta (Video Game Consoles)",
    "Valve (Video Game Consoles)",
    "Sega (Video Game Consoles)",
    "Atari (Video Game Consoles)",
    "Kinhank (Video Game Consoles)",
    "Anbernic (Video Game Consoles)",
    "Others (Video Game Consoles)"
  ]
}



    ],
  },



 {
    category: "💻 Electronics",
    subcategory: "🔊 Audio & Music Equipment",
    products: [
 {
  name: "Speaker",
  models: [
    
    "JBL",
    "Oraimo",
    "Zealot",
    "Anker (Soundcore)",
    "Bose",
    "Harman Kardon",
    "Samsung",
    "LG",
    "Sony",
    "Apple (HomePod)",
    "Amazon (Echo)",
    "Google (Nest)",
    "Xiaomi",
    "Djack",
    "Havit",
    "Polystar",
    "Ailipu",
    "Soundprince (Professional)",
    "Behringer (Professional)",
    "Mackie (Professional)",
    "Wharfedale (Professional)", "Others"
  ]
}


, 
  
{
  name: "Microphones",
  models: [
    
    "Shure",
    "Rode",
    "Boya",
    "Sennheiser",
    "AKG",
    "Maono",
    "Samson",
    "Blue",
    "Audio-Technica",
    "Behringer",
    "HyperX",
    "Razer",
    "Green Lion",
    "Hollyland",
    "Saramonic",
    "JBL",
    "Wharfedale",
    "Voximic",
    "Ulanzi",
    "Zing",
    "Others"
  ]
}
,
{
  name: "Sound Systems",
  models: [
    
    "Sony",
    "LG",
    "JBL",
    "Oraimo",
    "Samsung",
    "Hisense",
    "Djack",
    "Polystar",
    "Bruhm",
    "Qasa",
    "Binatone",
    "Akai",
    "Nexus",
    "Logitech",
    "Wharfedale",
    "Mackie",
    "Behringer",
    "F&D",
    "Ailipu", "Others"
  ]
}
,

{
  name: "Home Theater Systems",
  models: [
    
    "Sony",
    "LG",
    "Samsung",
    "JBL",
    "Oraimo",
    "Djack",
    "Polystar",
    "Hisense",
    "Ailipu",
    "Bruhm",
    "Nexus",
    "Qasa",
    "Binatone",
    "Akai",
    "F&D",
    "Zealot",
    "Logitech",
    "Anker",
    "Bose",
    "Harman Kardon",
    "Xiaomi",
    "Others"
  ]
}
,


{
  name: "Music Mixer",
  models: [
    
    "Yamaha",
    "Behringer",
    "Midas",
    "Soundcraft",
    "Mackie",
    "Allen & Heath",
    "PreSonus",
    "Pioneer DJ",
    "Numark",
    "Denon DJ",
    "Rane",
    "Native Instruments",
    "Wharfedale Pro",
    "Irukka",
    "Steck Audio",
    "Others"
  ]
}
 ,

 {
  name: "Walkie Talkies",
  models: [
    
    "Baofeng",
    "Motorola",
    "Kenwood",
    "Hytera",
    "Retevis",
    "Green Lion",
    "Icom",
    "ToooAir",
    "Baojie",
    "Entel",
    "Others"
  ]
}
,

{
  name: "Amplifier",
  models: [
    
    "Yamaha",
    "Wharfedale Pro",
    "Mackie",
    "Behringer",
    "Alto",
    "JBL",
    "Sound Prince",
    "Steck Audio",
    "Master Craft USA",
    "Irukka",
    "Audiocraft",
    "Warrior Audio",
    "Special Audio",
    "Pioneer",
    "Denon",
    "Jaguar",
    "Kelma Sound",
    "Titanic",
    "Ahuja (PA Systems)",
    "Fender (Guitar)",
    "Marshall (Guitar)",
    "Boss (Guitar)",
    "Laney (Guitar)",
    "Bugera (Guitar)",
    "Ashdown (Bass)", "Others"
  ]
}

     
    ],
  },

  
 {
    category: "💻 Electronics",
    subcategory: "📹 Security & Surveillance",
    products: [

{
  name: "CCTV Cameras",
  models: [
    
    "Hikvision",
    "Dahua",
    "EZVIZ",
    "TP-Link (Tapo series)",
    "Xiaomi (Mi Home Security Camera)",
    "V380 (Affordable wireless cameras)",
    "Uniview",
    "Bosch",
    "Axis",
    "ZKTeco",
    "Winpossee",
    "Imou",
    "CP Plus",
    "Others"
  ]
}

,

{
  name: "IP Cameras",
  models: [
    
    "Hikvision",
    "Dahua",
    "EZVIZ",
    "TP-Link",
    "V380",
    "Grandstream",
    "Ubiquiti",
    "ZKTeco",
    "Imou",
    "Ubox",
    "Uniview",
    "Foscam",
    "Others",
    "Samsung",
    "D-Link",
    "Xiaomi",
    "Avtech",
    "CP Plus"
  ]
}
,

{
  name: "Digital Video Recorders",
  models: [
    
    "Hikvision",
    "Dahua",
    "EZVIZ",
    "Winpossee",
    "CP Plus",
    "Uniview",
    "Longse",
    "Others (often listed by channel count like '4ch DVR')",
    "OEM"
  ]
}
,


{
  name: "CCTV Kit",
  models: [
    
    "Hikvision",
    "Dahua",
    "Winpossee",
    "TP-Link (Tapo series)",
    "ZOSI",
    "Reolink",
    "EZVIZ",
    "Uniview",
    "Grandstream",
    "Sunell",
    "Imou",
    "Others"
  ]
}
,

{
  name: "Motion Detectors",
  models: [
    
    "Ajax",
    "Bosch",
    "Hikvision",
    "Dahua",
    "EZVIZ",
    "TP-Link (Tapo)",
    "Tuya",
    "ZKTeco",
    "Sonoff",
    "Honeywell",
    "DSC",
    "CP Plus",
    "V380",
    "Legrand",
    "Others"
  ]
}
,

{
  name: "Spy Glasses",
  models: [
    
    "Ai Smart Eyeglass",
    "Green Lion Capture Smart Ai Glasses",
    "Wireless Smart Camera Glass",
    "HD 1080p Camera Glasses",
    "HD 720p Spy Eyeglass",
    "Bluetooth Spy Glasses with Camera",
    "Spy Camera Sunglasses",
    "Pinhole Spy Camera Glass",
    "Wearable Eyeglass Camera",
    "Meta Ray-Ban Wayfarer",
    "Others"
  ]
}

     
    ],
  },


{
    category: "💻 Electronics",
    subcategory: "📡 Networking Products",
    products: [
{
  name: "Router",
  models: [
    
    "TP-Link",
    "Mercusys",
    "Tenda",
    "MikroTik",
    "Ubiquiti",
    "ASUS",
    "Netgear",
    "Huawei",
    "Starlink",
    "D-Link",
    "Cisco",
    "Olax",
    "Google (Nest Wifi)",
    "Draytek",
    "iTel",
    "Samsung",
    "Amazon (eero)",
    "Others"
  ]
}

,

{
  name: "Switch",
  models: [
    
    "TP-Link",
    "Mercusys",
    "Tenda",
    "Ubiquiti",
    "Cisco",
    "D-Link",
    "Grandstream",
    "MikroTik",
    "Netgear",
    "Zyxel",
    "HP (Aruba)",
    "Huawei",
    "Tapo (by TP-Link)",
    "Legrand",
    "Schneider Electric",
    "ABB",
    "Others"
  ]
}

,

{
  name: "Modem",
  models: [
    
    "Huawei",
    "TP-Link",
    "Olax",
    "Spectranet",
    "Airtel",
    "MTN",
    "Ske",
    "Starlink",
    "Bolt+",
    "Universal",
    "ZTE",
    "Fibr",
    "Smile", "Others"
  ]
}



     
    ],
  },


   {
    category: "💻 Electronics",
    subcategory: "🧭 Computer Monitors",
    products: [
{
  name: "Computer Monitors",
  models: [
          "HP",
          "DELL",
          "Samsung",
              "LG",
          "Asus",
          "Acer",
           "Xiaomi", "Others"
        ]
}
    ],
  },


{
    category: "💻 Electronics",
    subcategory: "🖨️ Printers & Scanners",
    products: [
{
  name: "Printers & Scanners",
  models: [
    
    "HP",
    "Canon",
    "Epson",
    "Brother",
    "Xerox",
    "Kyocera",
    "Fujitsu (Scanners)",
    "Sharp",
    "Zebra (Label Printers)",
    "OKI",
    "Kodak",
    "Plustek (Scanners)",
    "Avision (Scanners)",
    "Fujifilm (Instax Printers)",
    "Samsung",
    "Others"
  ]
}


,

    ],
  },


 

 




  {
    category: "💻 Electronics",
    subcategory: "🧩 Computer Accessories",
    products: [
      {
        name: "Keyboards",
        models: [
          "Logitech",
          "Oraimo",
          "HP",
          "Microsoft",
          "Porodo",
          "Razer",
          "Redragon",
          "Havit",
          "Dell",
          "Apple",
          "Others"
        ]
      },
      {
        name: "Adapters",
        models: [
          "Anker",
          "Ugreen",
          "Baseus",
          "HP",
          "Dell",
          "Apple",
          "Microsoft",
          "Oraimo",
          "Satechi",
          "Others"
        ]
      },
      {
        name: "Mice",
        models: [
          "Logitech",
          "Oraimo",
          "HP",
          "Microsoft",
          "Razer",
          "Havit",
          "Dell",
          "Porodo",
          "Green Lion",
          "Apple",
          "Others"
        ]
      },
      {
        name: "Batteries",
        models: [
          "HP",
          "Dell",
          "Lenovo",
          "Apple",
          "Marsriva",
          "Ske",
          "Mercury",
          "Su-Kam",
          "Porodo",
          "Olax",
          "Evergood",
          "Others"
        ]
      },
      {
        name: "Cables (Computer Accessories)",
        models: [
          "Oraimo",
          "Anker",
          "Ugreen",
          "Baseus",
          "Ldnio",
          "Havit",
          "Budi",
          "Remax",
          "Others"
        ]
      },
      {
        name: "Webcams",
        models: [
          "Logitech",
          "Microsoft",
          "HP",
          "Dell",
          "Jabra",
          "Poly",
          "Havit",
          "Others"
        ]
      },
      {
        name: "Flash Drives",
        models: [
          "SanDisk",
          "Kingston",
          "HP",
          "Oraimo",
          "Samsung",
          "Others"
        ]
      }
    ]
  },
  {
    category: "💻 Electronics",
    subcategory: "⚙️ Accessories & Supplies for Electronics",
    products: [
       
      {
        name: "Photo & Video Accessories",
        models: [
          "DJI",
          "Godox",
          "Feelworld",
          "SmallRig",
          "Kodak",
          "Neewer",
          "Others"
        ]
      },
      {
        name: "Printers & Scanner Accessories",
        models: [
          "HP",
          "Canon",
          "Epson",
          "Brother",
          "Zebra",
          "Xprinter",
          "Others"
        ]
      },
      {
        name: "Networking Product Accessories",
        models: [
          "TP-Link",
          "Ubiquiti",
          "MikroTik",
          "Cisco",
          "Ugreen",
          "Others"
        ]
      },
      {
        name: "Audio & Music Accessories",
        models: [
          "Oraimo",
          "JBL",
          "Zealot",
          "Behringer",
          "Focusrite",
          "Shure",
          "Others"
        ]
      },
    
      {
        name: "Security & Surveillance Accessories",
        models: [
          "Hikvision",
          "Dahua",
          "ZKTeco",
          "Baofeng",
          "Porodo",
          "Others"
        ]
      },
      {
        name: "Game Console Accessories",
        models: [
          "Sony",
          "Microsoft",
          "Nintendo",
          "Logitech",
          "Others"
        ]
      },
     
     
      
    
    ]
  }













   ,
   {
    category: "💻 Electronics",
    subcategory: "🎮 Video Games",
    products: [

{
  name: "Video Games",
  models: [
    
    "EA Sports FC (formerly FIFA)",
    "God of War",
    "Grand Theft Auto",
    "Mortal Kombat",
    "Call of Duty",
    "Red Dead Redemption",
    "Cyberpunk 2077",
    "Minecraft",
    "Minecraft Dungeons",
    "Need for Speed",
    "Resident Evil",
    "NBA 2K",
    "The Last of Us",
    "Horizon Forbidden West",
    "Elden Ring",
    "Assassin's Creed",
    "Forza Horizon",
    "Marvel's Spider-Man",
    "Sonic Forces",
    "Mario Kart",
    "Roblox",
    "Valorant",
    "Fortnite",
    "Apex Legends",
    "Battlefield",
    "Tom Clancy's Ghost Recon",
    "Tekken",
    "Gears of War", "Others"
  ]
}



    ],
  },



  

  // 🚗 VEHICLES & TRANSPORT
  {
    category: "🚗 Vehicles & Transport",
    subcategory: "🚘 Cars",
    products: [
    {
  name: "Toyota",
  models: [
    
    "Camry",
    "Corolla",
    "Highlander",
    "RAV4",
    "Hilux",
    "Avalon",
    "Belta",
    "Avensis",
    "Land Cruiser Prado",
    "Land Cruiser",
    "FJ Cruiser",
    "Urban Cruiser",
    "Rush",
    "Fortuner",
    "Sienna",
    "HiAce",
    "Coaster",
    "Tacoma",
    "Tundra",
    "Venza",
    "Matrix",
    "Echo",
    "Yaris",
    "Prius",
    "4Runner", "Others"
  ]
}
,
     {
  name: "Honda",
  models: [
    
    "Accord",
    "Civic",
    "CR-V",
    "Pilot",
    "Passport",
    "HR-V",
    "Odyssey",
    "Crosstour",
    "City",
    "Fit",
    "Ridgeline",
    "Legend",
    "Shuttle",
    "Jazz",
    "Stream", "Others"
  ]
}
,
{
  name: "Mercedes-Benz",
  models: [
    
    "Mercedes-Benz A-Class",
    "Mercedes-Benz C-Class",
    "Mercedes-Benz E-Class",
    "Mercedes-Benz S-Class",
    "Mercedes-Benz CLA-Class",
    "Mercedes-Benz CLS-Class",
    "Mercedes-Benz G-Class",
    "Mercedes-Benz GLA-Class",
    "Mercedes-Benz GLB-Class",
    "Mercedes-Benz GLC-Class",
    "Mercedes-Benz GLE-Class",
    "Mercedes-Benz GLS-Class",
    "Mercedes-Benz M-Class",
    "Mercedes-Benz R-Class",
    "Mercedes-Benz V-Class",
    "Mercedes-Benz SL-Class",
    "Mercedes-Benz SLK-Class",
    "Mercedes-Benz AMG GT",
    "Mercedes-Benz EQE",
    "Mercedes-Benz EQS",
    "Mercedes-Maybach S-Class",
    "Mercedes-Benz 200E",
    "Mercedes-Benz 300E",
    "Mercedes-Benz 500SL", "Others"
  ]
}
,
      {
  name: "BMW",
  models: [
    
    "BMW 1 Series",
    "BMW 2 Series",
    "BMW 3 Series",
    "BMW 4 Series",
    "BMW 5 Series",
    "BMW 6 Series",
    "BMW 7 Series",
    "BMW 8 Series",
    "BMW X1",
    "BMW X2",
    "BMW X3",
    "BMW X4",
    "BMW X5",
    "BMW X6",
    "BMW X7",
    "BMW i3",
    "BMW i5",
    "BMW i7",
    "BMW i8",
    "BMW iX",
    "BMW M2",
    "BMW M3",
    "BMW M4",
    "BMW M5",
    "BMW M6",
    "BMW M8",
    "BMW Z4", "Others"
  ]
}
,
      {
  name: "Hyundai",
  models: [
    
    "Hyundai Accent",
    "Hyundai Creta",
    "Hyundai Elantra",
    "Hyundai Grandeur",
    "Hyundai Grand i10",
    "Hyundai Genesis",
    "Hyundai i10",
    "Hyundai ix35",
    "Hyundai Kona",
    "Hyundai Palisade",
    "Hyundai Santa Fe",
    "Hyundai Sonata",
    "Hyundai Tucson",
    "Hyundai Venue",
    "Hyundai Veracruz",
    "Hyundai Veloster",
    "Hyundai Staria",
    "Hyundai H-100",
    "Hyundai H1 Bus",
    "Hyundai Kona Electric",
    "Hyundai Ioniq", "Others"
  ]
}
, 
{
  name: "Ford",
  models: [
    
    "Ford Fusion",
    "Ford Edge",
    "Ford Explorer",
    "Ford Expedition",
    "Ford EcoSport",
    "Ford Territory",
    "Ford Bronco",
    "Ford Bronco Sport",
    "Ford Ranger",
    "Ford F-150",
    "Ford Transit",
    "Ford Taurus",
    "Ford Focus",
    "Ford Fiesta",
    "Ford Everest",
    "Ford Flex",
    "Ford Mustang",
    "Ford Kuga",
    "Ford Galaxy",
    "Ford S-Max",
    "Ford Figo",
    "Ford E-Series",
    "Ford Maverick", "Others"
  ]
}
 , {
  name: "Lexus",
  models: [
    
    "Lexus RX",
    "Lexus ES",
    "Lexus GX",
    "Lexus LX",
    "Lexus IS",
    "Lexus LS",
    "Lexus NX",
    "Lexus RC",
    "Lexus LC",
    "Lexus UX",
    "Lexus CT",
    "Lexus GS",
    "Lexus HS",
    "Lexus SC",
    "Lexus LFA",
    "Lexus RZ",
    "Lexus TX", "Others"
  ]
}

    ],
  },
  {
    category: "🚗 Vehicles & Transport",
    subcategory: "🏍️ Motorcycles & Scooters",
    products: [
      {
  name: "TVS",
  models: [
    
    "TVS King Deluxe Plus",
    "TVS King Deluxe",
    "TVS King Kargo",
    "TVS King Duramax Plus",
    "TVS King CNG",
    "TVS HLX+",
    "TVS HLX 125",
    "TVS XL 100 Heavy Duty",
    "TVS Neo NX",
    "TVS Neo AMI",
    "TVS Rockz",
    "TVS Apache RTR 200 4V",
    "TVS Apache RTR 160",
    "TVS Apache RTR 180",
    "TVS Apache RTR 310",
    "TVS Ronin",
    "TVS Jupiter",
    "TVS iQube",
    "TVS Raider 125", "Others"
  ]
}
,
      {
  name: "Honda (Motorcycles & Scooters)",
  models: [
    
    "Honda Ace 110",
    "Honda Ace CB150",
    "Honda Wave 110s",
    "Honda CG110",
    "Honda CG125",
    "Honda CB Unicorn",
    "Honda CB125F",
    "Honda Today",
    "Honda Dio",
    "Honda CBR Series",
    "Honda NC700X",
    "Honda PCX",
    "Honda Forza",
    "Honda Gold Wing",
    "Honda XR150L",
    "Honda CTX",
    "Others"
  ]
}
,
     {
  name: "Qlink",
  models: [
    
    "Qlink QGL-125 G12",
    "Qlink XP 200",
    "Qlink XF 200",
    "Qlink X-Ranger 200",
    "Qlink Rave 150",
    "Qlink Sprint 150",
    "Qlink D-Super 150",
    "Qlink Tiger 160",
    "Qlink Tiger 150",
    "Qlink Champion 200",
    "Qlink RKT",
    "Qlink Agro 150 (Tricycle)",
    "Qlink Agro 200 (Tricycle)",
    "Qlink Racer 250",
    "Qlink Target 110", "Others"
  ]
}
,
    {
  name: "Kymco",
  models: [
    
    "Kymco Xciting (various displacements)",
    "Kymco Agility (various displacements)",
    "Kymco Jockey CK 125",
    "Kymco Grand King 150",
    "Kymco AK550", "Others"
  ]
},
{
  name: "Bajaj",
  models: [
    
    "Bajaj Boxer (various displacements)",
    "Bajaj Pulsar (various displacements)",
    "Bajaj RE (Tricycle)",
    "Bajaj Dominar 400", "Others"
  ]
},
{
  name: "Yamaha (Motorcycles & Scooters)",
  models: [
    
    "Yamaha Crux",
    "Yamaha Gear",
    "Yamaha FZ Series (e.g., FZ6)",
    "Yamaha Majesty",
    "Yamaha Road Star",
    "Yamaha Scrambler", "Others"
  ]
},
{
  name: "Daylong (Motorcycles & Scooters)",
  models: [
    
    "Daylong DL125",
    "Daylong DGL125-K",
    "Daylong DL110-55",
    "Daylong RKV 200",
    "Daylong DL150-KT",
    "Daylong DL200-30",
    "Daylong Tricycles", "Others"
  ]
}

    ],
  },
  


   {
    category: "🚗 Vehicles & Transport",
    subcategory: "🔧 Spare Parts & Accessories",
    products: [
      
  
    {
      name: "Engine Parts",
      models: [
        
        "Engine Block",
        "Piston",
        "Crankshaft",
        "Spark Plugs (e.g., NGK, ACDelco)",
        "Filters (Oil, Air, Fuel)",
        "Gaskets and Seals",
        "Fuel Injectors",
        "Timing Belt",
        "Engine Oil (e.g., Mobil 1, Castrol)",
        "Coolant (e.g., Prestone)",
        "Ignition Coil",
        "Water Pump",
        "Radiator",
        "Engine Mounts",
        "Toyota IZZ Ignition Plug Coil", "Others"
      ]
    },
    {
      name: "Tyres & Wheels",
      models: [
        
        "Tyres (e.g., Michelin, Austone, Maxxis, Sailun)",
        "Rims (Alloy, Steel)",
        "Wheel Covers",
        "Wheel Bearings",
        "Wheel Nuts",
        "Tire Valves", "Others"
      ]
    },
    {
      name: "Electrical Parts",
      models: [
        
        "Alternator",
        "Starter Motor",
        "Car Battery (e.g., Solite, Runall)",
        "Fuse Box",
        "Wiring Harnesses",
        "Sensors (e.g., Oxygen Sensor)",
        "Ignition Switch",
        "Power Window Motors",
        "Switches (Headlight, Indicator)",
        "Electric Steering Rack", "Others"
      ]
    },
    {
      name: "Interior Accessories",
      models: [
        
        "Seat Covers (Leather, Fabric)",
        "Steering Wheel Covers",
        "Dashboard Mats",
        "Floor Mats",
        "Car Organizers",
        "Air Fresheners",
        "Interior Lighting (LEDs)",
        "Car Humidifiers",
        "Car Vacuum Cleaners", "Others"
      ]
    },
    {
      name: "Exterior Accessories",
      models: [
        
        "Headlights and Tail Lights",
        "Bumpers (Front and Rear)",
        "Grilles",
        "Side Mirrors",
        "Car Covers",
        "Window Visors",
        "Spoilers",
        "Body Kits",
        "Mudguards",
        "License Plate Frames", "Others"
      ]
    },
    {
      name: "Audio Parts",
      models: [
        
        "Car Stereos (e.g., Android Screens, 2-DIN Stereos)",
        "Speakers (e.g., JBL, Others)",
        "Subwoofers",
        "Amplifiers",
        "Bluetooth Kits",
        "MP3 Players",
        "Audio Adapters (e.g., Bluetooth FM Transmitters)",
        "Wiring Kits", "Others"
      ]
    }
  


    ],
  },



   {
    category: "🚗 Vehicles & Transport",
    subcategory: "🚜 Heavy Machinery",
    products: [
      
 
    {
      name: "Excavators",
      models: [
        
        "Caterpillar (CAT)",
        "Komatsu",
        "Hitachi",
        "Volvo",
        "Sany",
        "JCB",
        "XCMG",
        "Hyundai",
        "Doosan",
        "Kubota (Mini Excavators)",
        "Bobcat (Mini Excavators)",
        "Shantui",
        "Others"
      ]
    },
    {
      name: "Cranes",
      models: [
        
        "Grove",
        "Terex",
        "Sany",
        "XCMG",
        "Zoomlion",
        "Kato",
        "Link-Belt",
        "Liebherr",
        "Manitowoc",
        "Konecranes",
        "Others"
      ]
    },
    {
      name: "Forklifts",
      models: [
        
        "Toyota",
        "Caterpillar (CAT)",
        "UN",
        "TCM",
        "Manitou",
        "XCMG",
        "Zoomlion",
        "Lonking",
        "Samuk",
        "Hyster",
        "Yale",
        "Komatsu",
        "Linde",
        "Others"
      ]
    },
    {
      name: "Bulldozers",
      models: [
        
        "Caterpillar (CAT)",
        "Komatsu",
        "Shantui",
        "LiuGong",
        "Zoomlion",
        "Others"
      ]
    },
    {
      name: "Tractors",
      models: [
        
        "Massey Ferguson",
        "New Holland",
        "John Deere",
        "Ford",
        "Farmtrac",
        "Sonalika",
        "Powertrac",
        "Fiat",
        "Kubota",
        "Case IH",
        "Same",
        "TAVOL",
        "Others"
      ]
    },
    {
      name: "Concrete Mixers",
      models: [
        
        "HOWO",
        "Sany",
        "XCMG",
        "Liebherr",
        "Carmix",
        "DGM",
        "Hellog",
        "Camel",
        "Others (Pan Mixers, Self-Loaders)"
      ]
    },
    {
      name: "Wheel Loaders",
      models: [
        
        "Caterpillar (CAT)",
        "LiuGong",
        "XCMG",
        "Shantui",
        "Komatsu",
        "SDLG",
        "Sany",
        "DMW",
        "Case",
        "Others"
      ]
    }
  


    ],
  },

 

//Home and fuitures

 {
    category: "🏠 Home, Furnishing & Appliances",
    subcategory: "🛋️ Furniture",
    products: [
     
 
    {
      name: "Sofas",
      models: [
        
        "Nigerian Crafted",
        "Turkish (imported design)",
        "L-Shape Sofas",
        "Corner Sofas",
        "7-Seater Sofas",
        "Leather Sofas",
        "Fabric Sofas",
        "Modular Sofas",
        "Chesterfield Sofas",
        "Others"
      ]
    },
    {
      name: "Beds Frame",
      models: [
        
        "Nigerian Crafted",
        "HDF Bed Frames",
        "Divan Beds",
        "Upholstered Bed Frames",
        "Metal Bed Frames",
        "King Size Beds (6x6)",
        "Queen Size Beds (5x6)",
        "Bunk Beds",
        "Storage Beds",
        "Others"
      ]
    },
     {
      name: "Beds",
      models: [
        
        "Nigerian Crafted",
        "HDF Bed",
        "Divan Beds",
        "Upholstered Bed",
        "Metal Bed",
        "King Size Beds (6x6)",
        "Queen Size Beds (5x6)",
        "Bunk Beds",
        "Storage Beds",
        "Others"
      ]
    },
    {
      name: "Dining Sets",
      models: [
        
        "Nigerian Crafted",
        "Marble Top Dining Sets",
        "Wooden Top Dining Sets",
        "Glass Top Dining Sets",
        "Rattan Dining Sets",
        "4-Seater Dining Sets",
        "6-Seater Dining Sets",
        "Portable Dining Sets",
        "Others"
      ]
    },
    {
      name: "Wardrobes",
      models: [
        
        "Nigerian Crafted",
        "HDF Wardrobes",
        "Wooden Standing Wardrobes",
        "Plastic Wardrobes",
        "Sliding Door Wardrobes",
        "Walk-in Closets",
        "2-Door Wardrobes",
        "3-Door Wardrobes",
        "Others"
      ]
    },
    {
      name: "Tables & Chairs",
      models: [
        
        "Office Chairs",
        "Center Tables",
        "Side Stools",
        "Coffee Tables",
        "Office Tables",
        "Plastic Chairs",
        "Eames-Inspired Chairs",
        "Swivel Chairs",
        "Executive Chairs",
        "Others"
      ]
    }
  


   
   
        ],
  },
   {
    category: "🏠 Home, Furnishing & Appliances",
    subcategory: "🖼️ Home Decor",
    products: [
    

    {
      name: "Curtains & Drapes",
      models: [
        
        "Home Interiors (Custom Fabrics)",
        "Turkish Style Curtains",
        "Day and Night Blinds",
        "Naomi Curtain Designs",
        "Blackout Curtains",
        "Magic Mesh Curtains",
        "TM Interiors",
        "Others"
      ]
    },
    {
      name: "Wall Art",
      models: [
        
        "Canvas Wall Art",
        "Framed Wall Art",
        "Acrylic on Canvas",
        "PU Stone Wall Decor",
        "Islamic Calligraphy Art",
        "Abstract Art Pieces",
        "Others"
      ]
    },
    {
      name: "Clocks",
      models: [
        
        "DIY Wall Clocks",
        "Digital LED Clocks",
        "Metal Wall Clocks",
        "Grandfather Standing Clocks",
        "Vintage Wall Clocks",
        "Rikon Wall Clocks",
        "Others"
      ]
    },
    {
      name: "Rugs & Carpets",
      models: [
        
        "Turkish Style Carpets",
        "Home Interiors (Custom Rugs)",
        "Shaggy Carpets",
        "Center Rugs",
        "Artificial Grass Rugs",
        "Carpet Tiles",
        "Canadian Origin Rugs",
        "Others"
      ]
    },
    {
      name: "Mirrors",
      models: [
        
        "LED Mirrors",
        "Full-Length Mirrors",
        "Decorative Mirrors",
        "Frameless Mirrors",
        "Acrylic Mirrors",
        "Cabinet Mirrors",
        "Mmaat Mirrors",
        "Others"
      ]
    },
{
name: "Mattresses",
models: [
"Mouka (Mattresses)",
"Vitafoam (Mattresses)",
"Prestige (Mattresses)",
"Winco (Mattresses)",
"Olive (Mattresses)",
"Unifoam (Mattresses)",
"Intex (Mattresses)",
"Green Earth",
"Canadian (Imported)",
"Others (Mattresses)"
]
}
,
{
name: "BedSheet & Duvet",
models: [
"Mouka (BedSheet & Duvet)",
"Vitafoam (BedSheet & Duvet)",
"Homebase (BedSheet & Duvet)",
"Miniso (BedSheet & Duvet)",
"IKEA (BedSheet & Duvet)",
"Lenuo (BedSheet & Duvet)",
"Canadian (Imported/Generic brands)",
"Others (BedSheet & Duvet)"
]
},
{
name: "Pillows",
models: [
"Mouka (Pillows)",
"Vitafoam (Pillows)",
"Homebase (Pillows)",
"Miniso (Pillows)",
"IKEA (Pillows)",
"Lenuo (Pillows)",
"Intex (Air pillows)",
"Canadian (Imported/Generic Pillows)",
"Others (Pillows)"
]
}

    ],
  },
    {
    category: "🏠 Home, Furnishing & Appliances",
    subcategory: "🍳 Kitchen Appliances",
    products: [
     
  
    {
      name: "Blenders",
      models: [
        
        "Master Chef",
        "Polystar",
        "Binatone",
        "Century",
        "Nexus",
        "Silver Crest",
        "NutriBullet",
        "Kenwood",
        "Panasonic",
        "Midea",
        "Scanfrost",
        "Russell Hobbs",
        "Crown Star",
        "Itel",
        "Sokany",
        "Raf",
        "Nima",
        "Bardefu",
        "VTCL",
        "Others"
      ]
    },
    {
      name: "Microwaves",
      models: [
        
        "LG",
        "Samsung",
        "Hisense",
        "Haier Thermocool",
        "Nexus",
        "Scanfrost",
        "Polystar",
        "Midea",
        "Binatone",
        "Maxi",
        "Century",
        "QASA",
        "Akai",
        "Sonik",
        "Panasonic",
        "Candy",
        "Master Chef",
        "Others"
      ]
    },
    {
      name: "Cookers",
      models: [
        
        "Nexus",
        "Maxi",
        "Polystar",
        "Haier Thermocool",
        "Scanfrost",
        "Midea",
        "Century",
        "Boscon",
        "Skyrun",
        "Aeon",
        "Sokany",
        "Eurosonic",
        "Duravolt",
        "QASA",
        "Master Chef",
        "Sostar",
        "Others"
      ]
    },
    {
      name: "Refrigerators",
      models: [
        
        "LG",
        "Samsung",
        "Hisense",
        "Haier Thermocool",
        "Nexus",
        "Scanfrost",
        "Polystar",
        "Midea",
        "Bruhm",
        "Century",
        "Skyrun",
        "Binatone",
        "Royal",
        "Tamashi",
        "Snowsea",
        "Others"
      ]
    },
    {
  name: "Air Fryers",
  models: [
    "Philips",
    "Ninja",
    "Cosori",
    "Instant Pot",
    "Tower",
    "Silvercrest",
    "Binatone",
    "Scanfrost",
    "Kenwood",
    "Black & Decker",
    "Midea",
    "Century",
    "Russell Hobbs",
    "Ambiano",
    "Nutribullet",
    "Others"
  ]
},
    {
      name: "Electric Kettles",
      models: [
        
        "Binatone",
        "Century",
        "Polystar",
        "Nexus",
        "Scanfrost",
        "Haier Thermocool",
        "QASA",
        "Russell Hobbs",
        "Kinelco",
        "Saisho",
        "Syinix",
        "Master Chef",
        "Boscon",
        "Pyramid",
        "Salter",
        "Goodmans",
        "Others"
      ]
    }
  


    ],
  },
    {
    category: "🏠 Home, Furnishing & Appliances",
    subcategory: "💡 Lighting",
    products: [
    
 
    {
      name: "Bulbs",
      models: [
        
        "Philips",
        "Osram",
        "GE",
        "Sona",
        "V-TAC",
        "Lontor",
        "AKT Lighting",
        "TP-Link Tapo Smart Bulb",
        "Rechargeable LED Bulbs",
        "Filament Bulbs",
        "Others"
      ]
    },
    {
      name: "Ceiling Lights",
      models: [
        
        "Precise Lighting",
        "Philips Downlights",
        "EGLO",
        "AKT Lighting Panel Lights",
        "Chandeliers",
        "Pendant Lights",
        "Pop Spot Lights",
        "LED Panel Lights",
        "Modern LED Ceiling Light",
        "Others"
      ]
    },
    {
      name: "Lamps",
      models: [
        
        "Lontor Rechargeable",
        "QASA Rechargeable",
        "Sun King Solar",
        "Sonik Rechargeable",
        "IKEA Barlast",
        "Sunset Lamp",
        "Table Lamps",
        "Floor Lamps",
        "Rechargeable LED Reading Lamp",
        "Others"
      ]
    },
    {
      name: "Outdoor Lighting",
      models: [
        
        "AKT Lighting Floodlights",
        "Philips Streetlights",
        "Sms Solar Lights",
        "Sukhig Solar Floodlights",
        "Big Jeff Solar Lights",
        "Solar Street Lights",
        "LED Floodlights",
        "Fence & Wall Lamps",
        "Solar Powered Lights",
        "Others"
      ]
    }
  

 ],
  },
     {
    category: "🏠 Home, Furnishing & Appliances",
    subcategory: "📺 Home Electronics" ,
    products: [
     
    
    
    
 
    {
      name: "Washing Machines",
      models: [
        
        "LG",
        "Samsung",
        "Hisense",
        "Haier Thermocool",
        "Scanfrost",
        "Polystar",
        "Midea",
        "Bruhm",
        "Century",
        "Nexus",
        "Aeon",
        "Daewoo",
        "Skyrun",
        "Syinix",
        "Akai",
        "Royal",
        "Others"
      ]
    },
    {
      name: "Air Conditioners",
      models: [
        
        "LG",
        "Samsung",
        "Hisense",
        "Haier Thermocool",
        "Midea",
        "Daikin",
        "Gree",
        "Nexus",
        "Scanfrost",
        "TCL",
        "Royal",
        "Panasonic",
        "Firman",
        "Kenstar",
        "Bruhm",
        "Others"
      ]
    },
    {
      name: "Vacuum Cleaners",
      models: [
        
        "Oraimo",
        "Eufy",
        "Green Lion",
        "Roborock",
        "Ecovacs",
        "Ingco",
        "Beldray",
        "Bosch",
        "Karcher",
        "Samsung",
        "Philips",
        "Lexical",
        "Sokany",
        "Raf",
        "Rite Tek",
        "Black and Decker",
        "Others"
      ]
    },
    {
      name: "Irons",
      models: [
        
        "Philips",
        "Binatone",
        "Scanfrost",
        "Russell Hobbs",
        "Kenwood",
        "Tefal",
        "Boscon",
        "Sokany",
        "Raf",
        "Hisense",
        "Beldray",
        "Polystar",
        "Century",
        "SMP",
        "QASA",
        "Others"
      ]
    },
    {
      name: "Sewing Machines",
      models: [
        
        "Singer",
        "Brother",
        "Juki",
        "Butterfly",
        "Two Lion",
        "Emel",
        "Victoria",
        "Kingy",
        "Others"
      ]
    },
    {
      name: "Water Heaters",
      models: [
        
        "Ariston",
        "Maxi",
        "Polystar",
        "Midea",
        "Bruhm",
        "Binatone",
        "Linsan",
        "Nexus",
        "Scanfrost",
        "CWAY",
        "LG",
        "Kenstar",
        "Akai",
        "Kent",
        "Panasonic",
        "Others"
      ]
    },
    {
      name: "Fans",
      models: [
        
        "QASA",
        "Century",
        "Polystar",
        "Binatone",
        "OX",
        "Lontor",
        "Duravolt",
        "Solar Powered Fans",
        "Rechargeable Fans",
        "Akai",
        "Kenwood",
        "KDK",
        "Orl",
        "Sonik",
        "Others"
      ]
    }
  


    
    
    
    
    ],
  },
  // 💄 STYLE & BEAUTY
  {
    category: "💄 Style & Beauty",
    subcategory: "🧥 Men’s Fashion",
    "products": [
    {
      "name": "Clothing",
      "models": [
        "Formal Shirts",
        "Trousers",
        "Jeans",
        "Suits & Blazers",
        "T-Shirts",
        "Polos",
        "Jackets",
        "Hoodies & Sweatshirts",
        "Shorts",
        "Native Wears",
        "Sportswear",
        "Others"
      ]
    },
    {
      "name": "Shoes",
      "models": [
        "Loafers",
        "Sneakers",
        "Sandals & Slippers",
        "Boots",
        "Dress Shoes",
        "Gym Shoes",
        "Others"
      ]
    },
    {
      "name": "Accessories",
      "models": [
        "Belts",
        "Watches",
        "Wallets",
        "Ties & Pocket Squares",
        "Sunglasses",
        "Jewelry",
        "Caps & Hats",
        "Socks",
        "Others"
      ]
    },
    {
      "name": "Others (Men’s Fashion)",
      "models": [
        "Native Caps (Fila)",
        "Undergarments (Boxers, Briefs)",
        "Perfumes & Colognes",
        "Grooming Products",
        "Bags & Backpacks",
        "Others"
      ]
    }
  ]
  },
  {
    category: "💄 Style & Beauty",
    subcategory: "👠 Women’s Fashion",
    "products": [
    {
      "name": "Dresses",
      "models": [
        "Casual Dresses",
        "Romantic Dresses",
        "Office Dresses",
        "Party Dresses",
        "Formal Gowns",
        "Maxi Dresses",
        "Midi Dresses",
        "Mini Dresses",
        "Vintage Style Dresses",
        "Ankara Dresses",
        "Abayas/Kaftans",
        "Others"
      ]
    },
    {
      "name": "Shoes",
      "models": [
        "High Heels",
        "Flat Shoes",
        "Sneakers",
        "Sandals",
        "Ankle Boots",
        "Pumps",
        "Brogues",
        "Slip-ons",
        "Others"
      ]
    },
    {
      "name": "Jewelry",
      "models": [
        "Coral Beads",
        "Gold Plated Necklaces",
        "Statement Necklaces",
        "Layered Necklaces",
        "Earrings",
        "Bracelets & Bangles",
        "Rings",
        "Anklets",
        "Waist Beads",
        "Others"
      ]
    },
    {
      "name": "Bags",
      "models": [
        "Handbags",
        "Clutches",
        "Backpacks",
        "Crossbody Bags",
        "Wallets & Purses",
        "Designer Replicas",
        "Woven Bags",
        "Others"
      ]
    }
  ],
  },
  {
    category: "💄 Style & Beauty",
    subcategory: "💄 Cosmetics & Skincare",
   "products": [
    {
      "name": "Makeup",
      "models": [
        "Foundation",
        "Lipstick",
        "Mascara",
        "Eyeliner",
        "Eyeshadow",
        "Concealer",
        "Primer",
        "Blush",
        "Highlighter",
        "Setting Spray",
        "Makeup Brushes & Tools",
        "Others"
      ]
    },
    {
      "name": "Skincare",
      "models": [
        "Moisturizer",
        "Serum",
        "Sunscreen",
        "Cleanser",
        "Toner",
        "Face Masks",
        "Acne Treatment",
        "Body Lotion",
        "Exfoliator/Scrubs",
        "Eye Cream",
        "Others"
      ]
    },
    {
      "name": "Haircare",
      "models": [
        "Shampoo",
        "Conditioner",
        "Oil (Argan, Castor, Coconut)",
        "Hair Treatments & Masks",
        "Styling Products (Gel, Spray, Wax)",
        "Wigs & Hair Extensions",
        "Hair Tools (Straighteners, Dryers)",
        "Others"
      ]
    },
    {
      "name": "Others (Cosmetics & Skincare)",
      "models": [
        "Perfumes & Fragrances",
        "Body Lotions",
        "Nail Polish & Care",
        "Manicure/Pedicure Tools",
        "Body Sprays & Mists",
        "Bath & Shower Products",
        "Others"
      ]
    }
  ],
  },

  {
  "category": "💄 Style & Beauty",
  "subcategory": "💇 Hair & Beauty Tools",
  "products": [
    {
      "name": "Hair Tools",
      "models": [
        "Hair Straighteners & Flat Irons",
        "Hair Dryers & Blow Dryers",
        "Curling Irons & Wands",
        "Hair Clippers & Trimmers (Barbing)",
        "Hair Rollers & Curlers",
        "Hair Brushes & Combs",
        "Hair Extensions & Wigs Tools",
        "Others"
      ]
    },
    {
      "name": "Nail Tools & Care",
      "models": [
        "Manicure & Pedicure Kits",
        "Nail Drills & Files",
        "UV/LED Nail Lamps (Nail dryers)",
        "Nail Polish (Gels, Normal)",
        "Artificial Nails & Tips",
        "Nail Art Accessories & Stickers",
        "Cuticle Oils & Removers",
        "Others"
      ]
    },
    {
      "name": "Skincare & Makeup Tools",
      "models": [
        "Makeup Brushes & Sponges (Blenders)",
        "Foundation Applicators",
        "Eyelash Curlers",
        "Face Cleansing Brushes",
        "Microneedling Derma Rollers",
        "Blackhead Removers",
        "Facial Steamers",
        "Others"
      ]
    },
    {
      "name": "Saloon & Spa Equipment",
      "models": [
        "Salon Chairs",
        "Hair Washing Sinks",
        "Spa Beds & Massage Tables",
        "Sterilizers & Disinfectors",
        "Waxing Kits & Heaters",
        "Tattoo Equipment",
        "Others"
      ]
    }
  ]
}
,
 {
  "category": "💄 Style & Beauty",
  "subcategory": "🧳 Luggage & Travel Bags",
  "products": [
    {
      "name": "Backpacks",
      "models": [
        "Laptop Backpacks",
        "School Backpacks",
        "Hiking & Outdoor Backpacks",
        "Travel Backpacks",
        "Casual Daypacks",
        "Anti-theft Backpacks",
        "Drawstring Bags",
        "Others"
      ]
    },
    {
      "name": "Travel Bags",
      "models": [
        "Suitcases & Hardside Luggage",
        "Duffel Bags (Wheeled and soft)",
        "Carry-On Luggage",
        "Trolley Bags",
        "Garment Bags",
        "Weekender Bags",
        "Messenger Bags",
        "Others"
      ]
    }
  ]
}
,
  // 💼 COMMERCIAL EQUIPMENT & TOOLS
  {
    category: "🏭 Commercial Equipment & Tools",
    subcategory: "🧾 Retail & Store Equipment",
    products: [
     
  {
    "name": "Mannequins",
    "models": [
      "Others",
      "Bololo",
      "Adanma"
    ]
  },
  {
    "name": "Commercial Scales",
    "models": [
      "Camry",
     
      "Kira",
      "Maxwell",
      "Sofrank",
      "SF-400",
      "Flex",
      "Kam",
      "Sopuru",
      "Others"
    ]
  },
  {
    "name": "Showcases",
    "models": [
      "Bruhm",
      "Polystar",
      "Snowsea",
      "Tekno Cool",
      "Hisense",
      "Restpoint",
      "Beko",
      "Nexus",
      "Omaha",
      "Scanfrost",
      "Others"
    ]
  },
  {
    "name": "POS Terminals",
    "models": [
      "Moniepoint",
      "Pocketmoni",
      "Flutterwave",
      "Baxi",
      "Nomba",
      "Interswitch",
      "Kongapay",
      "Opay",
      "Nexgo",
      "Hiphen",
      "Premax",
      "Licon",
      "Verifone",
      "DTL",
      "Aures",
    
      "Others"
    ]
  },
  {
    "name": "Shelves",
    "models": [
      "Others"
    ]
  },
  {
    "name": "Trolleys",
    "models": [
     
      "Others"
    ]
  },
  {
    "name": "Barcode Scanners",
    "models": [
      "Super Scanner",
      "Honeywell",
      "Datalogic",
      "Zebra",
      "Motorola",
      "Licon",
      "Efficient Networks",
      "Netum",
      "Tao Tronics",
      "Veeda",
      "Hippoint",
      "X-9101c",
      "Cecon",
      "Evawgib",
  
      "Others"
    ]
  }

    ],
  },
 
  {
    category: "🏭 Commercial Equipment & Tools",
    subcategory: "🍽️ Restaurant & Catering Equipment",
    products: [
     
  {
    "name": "Ovens",
    "models": [
      "Polystar",
      "Nexus",
      "Maxi",
      "Century",
      "Skyrun",
      "Kenwood",
      "Homestar",
      "Binatone",
      "Hisense",
      "Tamashi",
      "Morphy Richards",
      "Masterchef",
      "Sokany",
      "Linkrich",
      "Silver Crest",
      "Pyramid",
      "Bosch",
      "Other"
    ]
  },
  {
    "name": "Refrigeration",
    "models": [
      "Hisense",
      "Skyrun",
      "LG",
      "Royal",
      "Snowsea",
      "Midea",
      "Bruhm",
      "Haier Thermocool",
      "Samsung",
      "Nexus",
      "Polystar", "Others"
    
    ]
  },
  {
    "name": "Mixers & Blenders",
    "models": [
      "Ninja",
      "Hamilton Beach",
      "Kenwood",
      
      "Silver Crest",
      "Buchymix",
      "Binatone",
      "Sokany",
      "Bardefu",
      "Russell Hobs",
      "Hisense",
      "Syinix",
      "Qasa",
      "Maximus",
      "Akai",
      "VCTL",
      "Bocsh",
      "Wngreat",
      "Scarlet",
      "Avinas",
      "Panasonic",
      "Nutribullet",
      "Rico",
      "Veronica",
      "Blendtec",
      "GSR",
      "Hoffmans",
      "Others",
     
    ]
  },
  {
    "name": "Cookers (Restaurant & Catering Equipment)",
    "models": [
      "Nexus",
      "Scanfrost",
      "Midea",
      "Bruhm",
      "Polystar",
      "Haier Thermocool",
      "AEON",
      "Maxi",
      "Hisense",
      "Samsung",
      "Skyrun",
      "Boscon",
      "Sokany",
      "Qasa",
      "Century",
      "Phiima",
      "Silver Crest",
      "Fred",
      "Raf",
      "Bosch",
      "Electrolux",
      "Linkrich", "Others"
      
    ]
  },
  {
    "name": "Shawarma Machines",
    "models": [
      "EFBA",
      "Tefal",
      "Others"
    ]
  }

    ],
  },
   
  {
    category: "🏭 Commercial Equipment & Tools",
    subcategory: "🛡️ Safety & Security Equipment",
    products: 
     [
  {
    "name": "Safetywear",
    "models": [
      "3M",
      "American Safety",
      "Safety Jogger",
      "MSA",
      "Portwest",
      "Dickies",
      "Tyvek",
      "Wenaas",
      "Redwing",
      "Arm Strong",
      "Oxford Spartan",
      "Mechanix",
      "Sod Flex",
      "Others"
    ]
  },
  {
    "name": "Barriers",
    "models": [
      "Avon",
      "Teso Tech",
      "Smart Airt",
      "Others"
    ]
  },
  {
    "name": "Safety Signs",
    "models": [
      "Others"
    ]
  },
  {
    "name": "Fire Extinguisher",
    "models": [
      "Angus",
      "Zika",
      "Fire Stop",
      "Zeta",
      "Others"
    ]
  },
  {
    "name": "Alarm Systems",
    "models": [
      "Zeta",
      "Hikvision",
      "Tuya",
      "Concept Plus",
      "C-Tec",
      "Chloride UK",
      "Teso Tech",
      "Scytek",
      "Avon",
      "Others"
    ]
  },
  {
    "name": "Safety Gloves & Sleeves",
    "models": [
      "Kong",
      "Zion",
      "Town Country",
      "Spear And Jackson",
      "Ingco",
      "Mechanix",
      "Beta",
      "Epic Height",
      "Gammex",
      "Seward",
      "Other"
    ]
  },
  {
    "name": "Biometric Machines",
    "models": [
      "Zkteco",
      "Realand",
      "Hikvision",
      "Hi-ppoint",
      "Dahua",
      "Dermalog",
      "Garrett",
      "U Are U",
      "A6",
      "Suprema",
      "Others"
    ]
  }

    ],
  },
 
   
  

  // 🏗️ BUILDING MATERIALS & ELECTRICALS
  {
    category: "🏗️ Building Materials & Electricals",
    subcategory: "🏗️ Building Materials & Supplies",
    products: [
  {
    "name": "Tiles",
    "models": [
      "Royal Tiles",
      "Spanish Tiles",
      "Italian Tiles",
      "Goodwill",
      "Gatsby Tiles",
      "Realonda",
      "Kian Gold",
      "Others"
    ]
  },
  {
    "name": "Roofing Materials",
    "models": [
      "Metcoppo",
      "Gerard",
      "Royal",
      "Metropoc",
      "Bond",
      "Step Tiles",
      "Long Span",
      "African Gaint",
      "Docherich", "Others"
    ]
  },
  {
    "name": "Flooring Materials",
    "models": [
      "SPC Flooring",
      "Vinyl Flooring",
      "Laminate Flooring",
      "Wooden Flooring",
      "Armstrong", "Others"
    ]
  },
  {
    "name": "Handrails",
    "models": [
      "Turkey 304",
      "Adaurora",
      "Sparkspot",
      "Advista",
      "Rot Iron",
      "Others"
    ]
  },
  {
    "name": "Cement",
    "models": [
      "Dangote",
      "BUA",
      "Lafarge",
      "Ibeto",
      "Unicem",
      "Powermax",
      "Ashaka",
      "Oyak",
      "Limma",
      "Express White Cement",
      "Gold White Cement",
      "Topshield",
      "Titan Waterproof",
      "Sika",
      "Armorcel",
      "Weber",
      "Rak",
      "Dr Fixit",
      "Bostik", "Others"
    ]
  },
  {
    "name": "Ceiling",
    "models": [
      "Gypsum Board",
      "Kalsi",
      "Alububble",
      "Rockwool",
      "Lunaflex",
      "Speedosky",
      "Turkish Gypsum",
      "Turkpop", "Others"
    ]
  },
  {
    "name": "Paint",
    "models": [
      "Dulux",
      "Berger",
      "Sandtex",
      "Caplux",
      "President",
      "Eagle",
      "Tran-Safe",
      "Mercy",
      "Hempel",
      "Prestige",
      "Vapour",
      "Abro", "Others"
    ]
  }
]
,
  },
  {
    category: "🏗️ Building Materials & Electricals",
    subcategory: "⚡ Electrical & Wiring",
    products: [
  {
    "name": "Generators",
    "models": [
      "Sumec Firman",
      "Elepaq",
      "Senwei",
      "Honda",
      "Yamaha",
      "Cummins",
      "Mikano",
      "Kipor",
      "Perkins",
      "FG Wilson",
      "Caterpillar",
      "Itc Power",
      "Henry West",
      "Bobo",
      "Odogwu",
      "Yoshita",
      "Tiger",
      "Kemage",
      "Senci",
      "Others"
    ]
  },
  {
    "name": "Soundproof Generators",
    "models": [
      "Perkins",
      "FG Wilson",
      "JMG",
      "Caterpillar",
      "Mikano",
      "Eletromak",
      "Sumec Firman",
      "Senwei",
      "Cummins",
      "Others"
    ]
  },
  {
    "name": "Electrical Cables",
    "models": [
      "Coleman",
      "Cutix",
      "Nigerchin",
      "MicCom",
      "MB",
      "Mmab",
      "Nexans Kabelmetal",
      "Vecan",
      "Others"
    ]
  },
  {
    "name": "Stabilizers",
    "models": [
      "Century",
      "Duravolt",
      "Qasa",
      "Bluegate",
      "Mercury",
      "Prag",
      "Binatone",
      "A&E Dunamis",
      "Firman",
      "Vintech",
      "Power Deluxe",
      "Jordy-Ele",
      "Cic Power Plus",
      "Others"
    ]
  },
  {
    "name": "Transformers",
    "models": [
      "ABB",
      "Astor",
      "Meksan",
      "Eren",
      "Siemens",
      "Others"
    ]
  },
  {
    "name": "Inverter Batteries",
    "models": [
      "Luminous",
      "Mercury",
      "Genus",
      "Felicity",
      "Sukam",
      "Prag",
      "Bluegate",
      "Microtek",
      "APC",
      "Kan",
      "Lemax",
      "Lento",
      "Amaron Quanta",
      "HBL Optimuz",
      "INDEX",
      "INDO",
      "Interlight",
      "Multipower",
      "Roy Solar",
      "Ruby",
      "SYNERGY",
      "SAKO",
      "TANDHAN POWER",
      "RUBITECH",
      "Starplus",
      "Mpower",
      "Soelix",
      "DOUKAM",
      "SUNFIT",
      "Others"
    ]
  },
  {
    "name": "Power Inverters",
    "models": [
      "Luminous",
      "Genus",
      "Lento",
      "KSTAR",
      "Beta",
      "Sukam",
      "Mercury",
      "Bluegate",
      "Prag",
      "Microtek",
      "APC",
      "Felicity Solar",
      "Zektron",
      "Deye",
      "SRNE",
      "Growatt",
      "SMA",
      "Victron Energy",
      "Fronius",
      "Huawei",
      "Schneider Electric",
      "Itel Energy",
      "Hithium",
      "PowMr",
      "Vanpa",
      "Others"
    ]
  }
]
,
  },
   {
    category: "🏗️ Building Materials & Electricals",
    subcategory: "🔋 Solar Energy & Power Systems",
    products: [
  {
    "name": "Solar Panels",
    "models": [
      "Felicity",
      "Jinko",
      "Canadian Solar",
      "JA Solar",
      "Trina Solar",
      "Suntech",
      "Sunfit",
      "Africell",
      "Longi",
      "Flames",
      "Sunflex",
      "Polly Panels",
      "Primtek"
    ]
  },
  {
    "name": "Solar Inverters",
    "models": [
      "Felicity Solar",
      "Luminous",
      "Sukam",
      "Mercury",
      "Bluegate",
      "Prag",
      "Genus",
      "Microtek",
      "APC",
      "Zektron",
      "Mopower",
      "Choice",
      "Growatt",
      "Must",
      "Deye",
      "SRNE",
      "PowMr",
      "SAKO", "Others"
    ]
  },
  {
    "name": "Solar Lights",
    "models": [
      "Felicity",
      "Sun King",
      "Akt",
      "Big Jeff",
      "Sms",
      "FFG",
      "Sukhig",
      "Ukc",
      "Primtek",
      "Wining Star",
      "Ganp", "Others"
    ]
  },
  {
    "name": "Deep Cycle Batteries",
    "models": [
      "Felicity",
      "Hyper Power",
      "Luxwatt",
      "Star Plus",
      "Choice",
      "Pattern",
      "Exide",
      "Cworth",
      "Delicity",
      "Neptune",
      "Royal Heart",
      "Energy Gold",
      "Croc",
      "Star Plus",
      "Sunfit",
      "SMS", "Others"
    ]
  },
  {
    "name": "Charge Controllers",
    "models": [
      "Felicity",
      "Must",
      "SMS",
      "Yohako",
      "Epever",
      "Tasha Energy",
      "Primtek",
      "Epsolar", "Others"
    ]
  },
  {
    "name": "Solar Generators",
    "models": [
      "Colasolar",
      "Haisic",
      "Alltop",
      "Itel Energy",
      "Must",
      "Lutian",
      "Fibon",
      "Sukhig",
      "Feisun",
      "Hi-Ppoint",
      "HIPHEN",
      "Beebeejump",
      "Duravolt",
      "Elepaq", "Others"
    ]
  },
  {
    "name": "Solar Accessories (Cables, Connectors, Mounts)",
    "models": [
      "Solar Cables",
      "MC4 Connectors",
      "Mounting Brackets",
      "Solar Water Pump",
      "Solar Pump Controller",
      "Breakers", "Others"
    ]
  },
  {
    "name": "Complete Solar Systems",
    "models": [
      "Maypatronic",
      "Felicity",
      "Elfbulb Power",
      "Green Power Nigeria",
      "Enterg Solar", "Others"
    ]
  }
]

  },
  {
    category: "🏗️ Building Materials & Electricals",
    subcategory: "🚿 Water & Plumbing Systems",
    products: [
  {
    "name": "Water Closet",
    "models": [
      "Golden Diamond",
      "Ideal",
      "Master",
      "Vstar",
      "Abb",
      "Abey",
      "Twyford",
      "Geberit",
      "Rockford",
      "Sweethome",
      "Ostini",
      "Bonjoy",
      "Crola",
      "England",
      "Executive",
     
      "Others"
    ]
  },
  {
    "name": "Water Taps",
    "models": [
      "Tonobo",
      "Twyford",
      "Sweethome",
      "Brimix",
      "Dura",
      "Ideal",
      "Sink Tap",
      "Mixer Tap",
      "Faucet",
      "Anti Rust Tap",
      "Pvc Tap",
      "Flexible Tap",
     
      "Others"
    ]
  },
  {
    "name": "Water Pumps",
    "models": [
      "Sumo",
      "Ingco",
      "Honda",
      "Capenda",
      "USK",
      "Frog",
      "Kama",
      "Tigmax",
      "Pedrollo",
      "Wilo",
      "Yamaha",
      "DABU",
      "Hydromatic",
      "KBS",
      "SIL",
      "Johnson",
      "Bolton",
      "Pentax",
      "Grundfos",
      "Elepaq",
      "Atlas",
      "Unic",
      "Total",
      "Sumec Firman",
      "Bosch",
      "Nova",
      "Fluidwell",
      "Samking",
      "Yohako",
      "Xems",
      "Sigma",
      "MAXMECH",
    
      "Others"
    ]
  },
  {
    "name": "Wash Hand Basins",
    "models": [
      "Twyford",
      "Golden Diamond",
      "Vstar",
      "Ideal",
      "Ceramic",
      "Glass Jar",
      "Cabinet",
      "Pedestal",
      "Countertop",
      "Wall Hung",
     
      "Others"
    ]
  },
  {
    "name": "Shower Mixers",
    "models": [
      "Choice",
      "Brimix",
      "Sweethome",
      "Imex",
      "Nitto",
      "Ideal",
      "Venus",
      "Kethin",
      "Piano",
      "Conduct",
      "Thermostatic",
      "Freestanding",
      "Wall Mount",

      "Others"
    ]
  },
  {
    "name": "Bathtubs",
    "models": [
      "Twyford",
      "Summer",
      "Ideal",
      "Jacuzzi",
      "Corner Whirlpool",
      "Massage Jets",
      "Fiber",
      "Acrylic",
      "Panel",
      "Freestanding",
      "Inflatable",
    
      "Others"
    ]
  },
  {
    "name": "Shower Cubicles",
    "models": [
      "Glass Jar",
      "Fulham",
      "Black Quadrant",
      "Zibra",
      "Square",
      "Sliding",
      "Frameless",
      "Steam",
      "Quadrant",
    
      "Others"
    ]
  }
]
,
  },

  // 🎮 LEISURE & ENTERTAINMENT
 
 
  {
    category: "🎯 Leisure & Entertainment",
    subcategory: "🏋️ Sports & Gym Gear",
    products: [
  {
    "name": "Treadmills",
    "models": [
      
      "American Fitness",
      "Supermax",
      "Supermax Pro",
      "Universal",
      "3G Cardio",
      "Bodyfit",
      "Fitness Quest",
      "German Machine",
      "Icon Health & Fitness",
      "Livestrong",
      "Power Max",
      "Pro Fitness",
      "Technofitness",
      "True Fitness",
      "Woodway", "Others"
    ]
  },
  {
    "name": "Bicycles & Tricycles",
    "models": [
      
      "Universal",
      "Best Choice Products",
      "Other (includes unbranded and specialized models)",
      "Hero",
      "Mercedes Benz",
      "Kent",
      "Huffy",
      "Mooncool"
    ]
  },
  {
    "name": "Exercise Bikes",
    "models": [
      "American Fitness",
      "Everlast",
      "Supermax",
      "Universal",
      "Bodyfit",
      "De Young",
     
      "Fitness Quest",
      "Livestrong",
      "Power Max",
      "Pro Fitness",
      "Technofitness",
      "Happy Gam",
      "Assault",
      "Magnetic Fitness",
      "DHZ", "Others"
    ]
  },
  {
    "name": "Dumbbells",
    "models": [
      "American Fitness",
      "Everlast",
      "Supermax",
      "Universal",
      "Bodygym",
      "Bodyflex",
      "De Young",
      
      "Power Max",
      "Pro Sport",
      "York Fitness",
      "Others",
      "Ms Fitness",
      "Ultimate Bodyfit"
    ]
  },
  {
    "name": "Tennis Tables",
    "models": [
      "Universal",
      "Joola",
      "American Fitness",
      "De Young",
      "Tablemate",
      "Butterfly",
      "Sponeta",
      "SMC (descriptive, also used as a brand by sellers)",
      "Stiga", "Others"
    ]
  },
  {
    "name": "Ab Exercise Machine",
    "models": [
      "Ab Coaster",
      "Ab Doer Twist",
      "Ab Rocket",
      "Ab Slide",
      "Abgymnic",
      "Abtronic",
      "Wonder Core",
      "Wellcare",
      "Bodyfit",
      "Revoflex",
      "Universal", "Others"
    ]
  }
]
,
  },
  


   {
    category: "🎯 Leisure & Entertainment",
    subcategory: "🎸 Musical Instruments",
    products: [
  {
    "name": "Guitars",
    "models": [
      "American Fitness",
      "Matushi",
      "LES PAUL",
      "Epiphone",
      "Gibson",
      "Fender",
      "Smiger",
      "Bullfighter",
      "Yamaha",
      "Ibanez",
      "AJC",
      "Watson",
      "Armstrong",
      "Kassy Venture",
      "Ultimate",
      "Behringer",
      "Nux",
      "D'addario",
      "Rich-Power",
      "Walden",
      "Thunder",
      "Others",
      "Takla",
      "Magna",
      "Vantage",
      "Road Dog"
    ]
  },
  {
    "name": "Keyboards (Musical Instruments)",
    "models": [
      "Logitech",
      "HP",
      "Yamaha",
      "Apple",
      "Akai Professional",
      "Arturia",
      "Nektar",
      "Native Instruments",
      "M Vave",
      "Meetion",
      "Dareu",
      "FREEWOLF",
      "Micropack",
      "Kensington",
      "Iciever",
      "Razer",
      "Alienware",
      "Asus Rog",
      "Omen",
      "Porodo",
      "Aula",
      "T-Wolf",
      "Aoc",
      "Microsoft",
      "Roccat",
      "Havit",
      "DELL",
      "LENOVO",
      "Others",
     
    ]
  },
  {
    "name": "Drums",
    "models": [
      "Alesis",
      "Behringer",
      "Medeli",
      "Pearl",
      "Db",
      "Yamaha",
      "Mapex",
      "Dw",
      "A&S",
      "Mackie",
      "SJC",
      "Virgin",
      "Kingzbeat",
      "Tama",
      "Toca",
      "Premier",
      "Others",
      "Champion Sound",
      "Infinity"
    ]
  },
  {
    "name": "Speaker (Musical Instruments)",
    "models": [
      "JBL",
      "Sound Prince",
      "Harman Kardon",
      "Zealot",
      "Djack",
      "Oraimo",
      "LG",
      "Greatstar",
      "Anker",
      "Hisense",
      "Edifier",
      "Zed",
      "Ym-audio",
      "Temeisheng",
      "Jabra",
      "Epos",
      "Tronsmart",
      "Google Nest",
      "Bose",
      "Remax",
      "Newcastle",
      "Wharfedale",
      "Mackkie",
      "Beosound",
      "Juice Sound",
      "Ahuja",
      "Imo-Monster",
      "Others",
      
    ]
  },
  {
    "name": "DJ Equipment",
    "models": [
      "Pioneer",
      "JBL",
      "Behringer",
      "Rane",
      "Denon DJ",
      "Numark",
      "Alphatheta",
      "Numark",
      "Marley",
      "Native Instruments",
      "Others",
      "LG",
      "Djack",
      "Rav",
      "Sound Prince",
      "Head",
      "Yamaha"
    ]
  },
  {
    "name": "Saxophones",
    "models": [
      "Yamaha",
      "Premier",
      "Selmer",
      "Hallmark",
      "Armstrong",
      "Antigua",
      "Schmid",
      "Steph Audio",
      "Daniel's Professional",
      "Custom Z",
      "Jupiter",
      "Others",
      "Eva"
    ]
  },
  {
    "name": "Music Stands",
    "models": [
      "Alctron",
      "Quik Lok",
      "Hercules",
      "Strong",
      "Homeflower",
      "Others"
    ]
  }
]
,
  },
];

export default productData;
